export interface Flashcard {
  id: number;
  question: string;
  answer: string;
  category: string;
  difficulty: "easy" | "medium" | "hard";
  explanation?: string;
}

export const flashcards: Flashcard[] = 
[
    {
        "id": 1,
        "question": "What is the primary role of a real estate broker?",
        "answer": "To act as an intermediary between buyers and sellers, facilitating transactions and overseeing sales associates.",
        "category": "Real Estate Brokerage",
        "difficulty": "easy",
        "explanation": "A broker's role is to manage and direct the business activities of a brokerage, including supervising licensed agents."
    },
    {
        "id": 2,
        "question": "What is the purpose of a brokerage office sign, according to Florida law?",
        "answer": "It must be clearly visible and contain the trade name (if any), the broker's name, and the words 'Licensed Real Estate Broker' or 'Lic. Real Estate Broker'.",
        "category": "Brokerage Offices",
        "difficulty": "medium",
        "explanation": "This is a mandatory requirement for all licensed brokerages to ensure transparency and compliance with Florida law."
    },
    {
        "id": 3,
        "question": "What is a sole proprietorship in the context of a real estate brokerage?",
        "answer": "A business owned by a single individual, who is personally liable for all business debts.",
        "category": "Business Structures",
        "difficulty": "easy",
        "explanation": "In a sole proprietorship, there is no legal distinction between the owner and the business."
    },
    {
        "id": 4,
        "question": "What is a principal office and what are its requirements?",
        "answer": "The main office of a real estate brokerage, which must be registered with the DBPR and have a sign at the entrance.",
        "category": "Brokerage Offices",
        "difficulty": "medium",
        "explanation": "Every brokerage must maintain a principal office for official business and records."
    },
    {
        "id": 5,
        "question": "How long must a real estate broker maintain business records?",
        "answer": "Five years from the date of the document.",
        "category": "Record Keeping",
        "difficulty": "easy",
        "explanation": "This requirement ensures a clear paper trail for all real estate transactions and is mandated by Florida law."
    },
    {
        "id": 6,
        "question": "What is an escrow account?",
        "answer": "An account for a broker to hold funds on behalf of others, such as earnest money deposits or security deposits.",
        "category": "Escrow Accounts",
        "difficulty": "easy",
        "explanation": "These accounts are for the protection of client funds and must be separate from the broker's personal or business operating accounts."
    },
    {
        "id": 7,
        "question": "What is commingling of funds?",
        "answer": "The illegal practice of mixing a client's money with the broker's personal or business funds.",
        "category": "Escrow Accounts",
        "difficulty": "medium",
        "explanation": "This is a serious violation that can lead to disciplinary action against a broker's license."
    },
    {
        "id": 8,
        "question": "What is conversion of funds?",
        "answer": "The illegal act of using a client's funds for a broker's personal or business expenses.",
        "category": "Escrow Accounts",
        "difficulty": "medium",
        "explanation": "This is a more severe offense than commingling and is considered a form of theft."
    },
    {
        "id": 9,
        "question": "What is the time frame for a broker to deposit a client's escrow funds?",
        "answer": "Immediately, which means no later than the end of the third business day following receipt of the funds.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "The 'immediately' rule is strict and requires swift action to protect client money."
    },
    {
        "id": 10,
        "question": "What is a limited partnership in a real estate brokerage?",
        "answer": "A business structure with at least one general partner with unlimited liability and one or more limited partners with liability limited to their investment.",
        "category": "Business Structures",
        "difficulty": "medium",
        "explanation": "Limited partners are typically investors who do not participate in the day-to-day management of the business."
    },
    {
        "id": 11,
        "question": "What is the purpose of the Florida Real Estate Commission (FREC) with regard to brokerage activities?",
        "answer": "To regulate and enforce the real estate license law, ensuring ethical and professional conduct.",
        "category": "Licensing and Regulation",
        "difficulty": "easy",
        "explanation": "FREC's role is to protect the public by overseeing all aspects of real estate practice in Florida."
    },
    {
        "id": 12,
        "question": "What must a sales associate do with an earnest money deposit they receive?",
        "answer": "Immediately deliver the deposit to their broker or the brokerage's office.",
        "category": "Escrow Accounts",
        "difficulty": "easy",
        "explanation": "A sales associate is not legally permitted to hold client funds; they must be passed on to the broker."
    },
    {
        "id": 13,
        "question": "What is a 'for sale' or 'for rent' sign requirement for a brokerage?",
        "answer": "The sign must be clear, legible, and include the broker's name and 'Licensed Real Estate Broker' or 'Lic. Real Estate Broker'.",
        "category": "Advertising",
        "difficulty": "medium",
        "explanation": "All advertising for real estate must be in the name of the brokerage and supervised by the broker."
    },
    {
        "id": 14,
        "question": "What is a blind advertisement?",
        "answer": "An advertisement that does not include the licensed name of the brokerage firm.",
        "category": "Advertising",
        "difficulty": "medium",
        "explanation": "Blind ads are illegal in Florida as they fail to disclose the identity of the brokerage firm."
    },
    {
        "id": 15,
        "question": "When can a broker hold escrow funds in an interest-bearing account?",
        "answer": "With the written permission of all parties and if the broker is designated as an escrow agent.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "Without written consent, any interest earned on escrow funds must go to the parties in the transaction."
    },
    {
        "id": 16,
        "question": "What is a limited liability company (LLC) in real estate?",
        "answer": "A business structure that provides the liability protection of a corporation while allowing for the tax benefits of a partnership.",
        "category": "Business Structures",
        "difficulty": "medium",
        "explanation": "An LLC is a popular choice for brokers because it shields their personal assets from business debts."
    },
    {
        "id": 17,
        "question": "What must a broker do if there is a dispute over escrow funds?",
        "answer": "Follow one of the four settlement procedures: mediation, arbitration, litigation, or an escrow disbursement order (EDO).",
        "category": "Escrow Disputes",
        "difficulty": "hard",
        "explanation": "Florida law outlines specific steps a broker must take to resolve an escrow dispute legally and ethically."
    },
    {
        "id": 18,
        "question": "What is an Escrow Disbursement Order (EDO)?",
        "answer": "A determination by the FREC as to who should receive disputed escrow funds.",
        "category": "Escrow Disputes",
        "difficulty": "medium",
        "explanation": "This is one of the four ways a broker can legally disburse disputed funds and be protected from liability."
    },
    {
        "id": 19,
        "question": "What is the purpose of the Real Estate Recovery Fund?",
        "answer": "To compensate individuals who have suffered monetary damages as a result of a licensed real estate professional's illegal or unethical actions.",
        "category": "Licensing and Regulation",
        "difficulty": "medium",
        "explanation": "The fund protects the public from losses caused by licensees, provided the licensee's actions were illegal or fraudulent."
    },
    {
        "id": 20,
        "question": "What are the rules regarding a broker's personal funds in an escrow account?",
        "answer": "A broker may place up to $1,000 of their own money into a sales escrow account, and up to $5,000 into a property management escrow account.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "These funds are meant to cover service charges or maintain the account, not to be commingled with client funds for business purposes."
    },
    {
        "id": 21,
        "question": "How should a broker handle a post-dated check received as an earnest money deposit?",
        "answer": "The broker must get written permission from the seller and immediately deposit the check at the agreed-upon date.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "A post-dated check is considered a promissory note and cannot be deposited until its date."
    },
    {
        "id": 22,
        "question": "What is a corporation 'for profit' in real estate?",
        "answer": "A business entity created to make a profit for its shareholders, which can be licensed to operate a brokerage.",
        "category": "Business Structures",
        "difficulty": "easy",
        "explanation": "A corporation is a separate legal entity from its owners, offering liability protection."
    },
    {
        "id": 23,
        "question": "What must be included in a brokerage's advertisement?",
        "answer": "The licensed name of the brokerage firm.",
        "category": "Advertising",
        "difficulty": "easy",
        "explanation": "This is a key requirement to prevent blind advertising and ensure the public knows who they are dealing with."
    },
    {
        "id": 24,
        "question": "What is a 'team' advertisement and what are the rules?",
        "answer": "An advertisement by a group of sales associates within a brokerage. It must include the licensed name of the brokerage.",
        "category": "Advertising",
        "difficulty": "medium",
        "explanation": "Team names cannot be used in a way that implies the team is a separate brokerage firm."
    },
    {
        "id": 25,
        "question": "How is an escrow account for a property management business different from a sales escrow account?",
        "answer": "A broker can place up to $5,000 of personal funds in a property management escrow account versus $1,000 in a sales escrow account.",
        "category": "Escrow Accounts",
        "difficulty": "medium",
        "explanation": "The higher limit for property management is to cover expenses such as repairs and maintenance for the managed properties."
    },
    {
        "id": 26,
        "question": "When can a broker be compensated by more than one party in a transaction?",
        "answer": "Only with the full knowledge and written consent of all parties to the transaction.",
        "category": "Brokerage Compensation",
        "difficulty": "hard",
        "explanation": "This rule prevents a conflict of interest and potential fraud."
    },
    {
        "id": 27,
        "question": "What is the consequence of a broker failing to account for escrow funds?",
        "answer": "This is a violation of real estate law and can lead to license suspension or revocation.",
        "category": "Escrow Accounts",
        "difficulty": "medium",
        "explanation": "Failing to account for funds is a serious breach of a broker's fiduciary duty."
    },
    {
        "id": 28,
        "question": "What is a general partnership in a real estate brokerage?",
        "answer": "A business structure in which two or more people agree to share in the profits and losses of a business, with each partner having unlimited personal liability.",
        "category": "Business Structures",
        "difficulty": "easy",
        "explanation": "In a general partnership, all partners share in the management and liability of the business."
    },
    {
        "id": 29,
        "question": "What is the purpose of the Florida Real Estate Recovery Fund?",
        "answer": "To pay for judgments against a licensee who has caused financial harm to a consumer.",
        "category": "Licensing and Regulation",
        "difficulty": "easy",
        "explanation": "It's a fund of last resort for consumers who are unable to collect on a judgment against a licensee."
    },
    {
        "id": 30,
        "question": "What is a joint venture?",
        "answer": "A temporary business relationship between two or more parties for a specific purpose or project.",
        "category": "Business Structures",
        "difficulty": "medium",
        "explanation": "It is not a permanent business structure and ends once the project is complete."
    },
    {
        "id": 31,
        "question": "What is a brokerage's responsibility when a sales associate changes employers?",
        "answer": "The previous broker must notify the FREC within 10 days of the change, and the associate must notify the DBPR.",
        "category": "Licensing and Regulation",
        "difficulty": "hard",
        "explanation": "This ensures that the sales associate's license remains active and properly associated with a brokerage."
    },
    {
        "id": 32,
        "question": "What is a limited liability partnership (LLP) in real estate?",
        "answer": "A business structure that protects partners from the debts and liabilities of other partners, while still sharing profits.",
        "category": "Business Structures",
        "difficulty": "hard",
        "explanation": "LLPs are often used by professionals like lawyers and accountants but can also be used in real estate."
    },
    {
        "id": 33,
        "question": "What is an office's requirement for its branch offices?",
        "answer": "Each branch office must be registered with the DBPR and its registration cannot be transferred.",
        "category": "Brokerage Offices",
        "difficulty": "medium",
        "explanation": "If a branch office moves, a new registration is required for the new location."
    },
    {
        "id": 34,
        "question": "What is a designated sales associate?",
        "answer": "A sales associate who acts as a single agent for a buyer and seller in the same transaction, with the knowledge and written consent of both parties.",
        "category": "Brokerage Activities",
        "difficulty": "hard",
        "explanation": "This can only happen in non-residential transactions where the parties have assets of over $1 million."
    },
    {
        "id": 35,
        "question": "What are the rules regarding a broker's trust account?",
        "answer": "It must be an FDIC-insured or an NCUA-insured account and be located in Florida.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "This protects client funds by ensuring the account is secure and regulated within the state."
    },
    {
        "id": 36,
        "question": "What is a referral fee and when is it legal?",
        "answer": "A fee paid to a person for directing business to a broker. It is only legal if the person is a licensed real estate professional.",
        "category": "Brokerage Compensation",
        "difficulty": "medium",
        "explanation": "It is illegal to pay a referral fee to an unlicensed individual for a real estate transaction."
    },
    {
        "id": 37,
        "question": "What is a trade name in real estate?",
        "answer": "A business name used by a brokerage that is different from the broker's personal name.",
        "category": "Advertising",
        "difficulty": "easy",
        "explanation": "A trade name must be registered with the DBPR and used in all brokerage advertising."
    },
    {
        "id": 38,
        "question": "What is the anti-trust law in the real estate business?",
        "answer": "Laws that prevent brokers from fixing commissions, boycotting competitors, or dividing territories.",
        "category": "Anti-Trust Laws",
        "difficulty": "medium",
        "explanation": "These laws are designed to promote competition and protect consumers."
    },
    {
        "id": 39,
        "question": "What is price-fixing?",
        "answer": "An illegal anti-trust activity where brokers conspire to set a fixed commission rate for their services.",
        "category": "Anti-Trust Laws",
        "difficulty": "medium",
        "explanation": "Commission rates are always negotiable and should not be set by industry collusion."
    },
    {
        "id": 40,
        "question": "What is market allocation?",
        "answer": "An illegal anti-trust activity where brokers agree to divide a market and not compete with each other in specific territories.",
        "category": "Anti-Trust Laws",
        "difficulty": "hard",
        "explanation": "This practice restricts consumer choice and is a violation of federal law."
    },
    {
        "id": 41,
        "question": "What is a group boycott?",
        "answer": "An illegal anti-trust activity where two or more brokers agree to not cooperate with a third broker.",
        "category": "Anti-Trust Laws",
        "difficulty": "hard",
        "explanation": "Group boycotts are intended to put a competitor out of business and are illegal."
    },
    {
        "id": 42,
        "question": "What is the difference between a branch office and a temporary shelter?",
        "answer": "A branch office is a permanent location registered with the state, while a temporary shelter is a temporary sales location that does not need to be registered.",
        "category": "Brokerage Offices",
        "difficulty": "hard",
        "explanation": "Temporary shelters are often used at a construction site for a limited time and do not hold records."
    },
    {
        "id": 43,
        "question": "What must a broker do if a buyer withdraws a purchase offer before it is accepted by the seller?",
        "answer": "The broker must return the earnest money deposit to the buyer.",
        "category": "Escrow Accounts",
        "difficulty": "easy",
        "explanation": "The deposit is only held in escrow if there is a binding contract, so it must be returned if no contract is formed."
    },
    {
        "id": 44,
        "question": "What is a single broker's responsibility in a transaction broker relationship?",
        "answer": "To provide limited representation to both parties, but without owing full fiduciary duties to either.",
        "category": "Brokerage Activities",
        "difficulty": "medium",
        "explanation": "A transaction broker must deal honestly and fairly, but does not represent either party as a single agent."
    },
    {
        "id": 45,
        "question": "What is a kickback in real estate?",
        "answer": "An unearned fee or rebate paid to a broker for directing business to a specific service provider, such as a mortgage lender or title company.",
        "category": "Brokerage Compensation",
        "difficulty": "hard",
        "explanation": "Kickbacks are illegal under the Real Estate Settlement Procedures Act (RESPA) unless a disclosure is made and a service is rendered."
    },
    {
        "id": 46,
        "question": "What is the penalty for a broker who engages in a blind advertisement?",
        "answer": "Disciplinary action by the FREC, including a fine or license suspension.",
        "category": "Advertising",
        "difficulty": "medium",
        "explanation": "Blind advertising is a direct violation of Florida's real estate advertising rules."
    },
    {
        "id": 47,
        "question": "What is a broker's duty regarding a transaction that is handled by a title company or attorney?",
        "answer": "The broker must still confirm that the escrow deposit has been made and get a written verification of the deposit within 10 business days.",
        "category": "Escrow Accounts",
        "difficulty": "hard",
        "explanation": "Even if the funds are not in their own account, the broker is still responsible for their proper handling."
    },
    {
        "id": 48,
        "question": "What is a general agent?",
        "answer": "An agent authorized to act for a principal in a specific range of business matters.",
        "category": "Laws of Agency",
        "difficulty": "easy",
        "explanation": "A property manager is a classic example of a general agent."
    },
    {
        "id": 49,
        "question": "What is a special agent?",
        "answer": "An agent authorized by a principal to perform a single act or transaction.",
        "category": "Laws of Agency",
        "difficulty": "easy",
        "explanation": "A real estate sales associate is a special agent for their broker in a specific transaction."
    },
    {
        "id": 50,
        "question": "What is a subagent?",
        "answer": "An agent of a person who is already acting as an agent for a principal.",
        "category": "Laws of Agency",
        "difficulty": "medium",
        "explanation": "In a listing agreement, a sales associate is a subagent of the seller's broker."
    },
    {
        "id": 51,
        "question": "What is a branch office license?",
        "answer": "A separate license required for each branch office a brokerage operates.",
        "category": "Brokerage Offices",
        "difficulty": "medium",
        "explanation": "This license is not transferable and is tied to a specific location."
    },
    {
        "id": 52,
        "question": "What is a broker-associate?",
        "answer": "A person who is qualified to be a broker but chooses to work as a sales associate for another broker.",
        "category": "Licensing and Regulation",
        "difficulty": "easy",
        "explanation": "They hold a broker's license but operate under the supervision of another broker."
    },
    {
        "id": 53,
        "question": "What are the rules regarding a broker's name on a sales associate's business card?",
        "answer": "The business card must have the brokerage's name on it, but it does not have to include the broker's name.",
        "category": "Advertising",
        "difficulty": "medium",
        "explanation": "The key is that the advertisement is clearly in the name of the licensed brokerage firm."
    },
    {
        "id": 54,
        "question": "What is a sole proprietor's responsibility for a brokerage office?",
        "answer": "The sole proprietor must be a licensed broker and is personally responsible for all brokerage activities.",
        "category": "Business Structures",
        "difficulty": "easy",
        "explanation": "This structure provides no liability protection, so the broker is fully exposed to legal claims."
    },
    {
        "id": 55,
        "question": "How long must a broker keep an inactive escrow account?",
        "answer": "The account can be closed immediately after all funds have been disbursed and the transaction is complete.",
        "category": "Escrow Accounts",
        "difficulty": "medium",
        "explanation": "There is no requirement to keep a dormant escrow account open."
    },
    {
        "id": 56,
        "question": "What is an escrow disbursement order?",
        "answer": "A determination by the FREC as to who is entitled to a disputed escrow deposit.",
        "category": "Escrow Disputes",
        "difficulty": "medium",
        "explanation": "This is a form of dispute resolution that removes the broker from liability."
    },
    {
        "id": 57,
        "question": "When can a broker refuse to disburse escrow funds when there's a dispute?",
        "answer": "A broker can refuse disbursement until the dispute is resolved through one of the four methods required by law.",
        "category": "Escrow Disputes",
        "difficulty": "hard",
        "explanation": "Disbursing funds prematurely could expose the broker to legal liability."
    },
    {
        "id": 58,
        "question": "What is the purpose of the FREC's probable cause panel?",
        "answer": "To investigate complaints against licensees and determine if there is a probable cause for disciplinary action.",
        "category": "Licensing and Regulation",
        "difficulty": "medium",
        "explanation": "This panel operates in a confidential manner to protect licensees from false accusations."
    },
    {
        "id": 59,
        "question": "What must a broker do if they change their business address?",
        "answer": "Notify the DBPR of the change within 10 days.",
        "category": "Brokerage Offices",
        "difficulty": "easy",
        "explanation": "This ensures that all records and licenses are up-to-date with the state."
    },
    {
        "id": 60,
        "question": "What is the difference between an inactive and a null and void license?",
        "answer": "An inactive license can be reactivated, while a null and void license requires the person to re-apply for a license from the beginning.",
        "category": "Licensing and Regulation",
        "difficulty": "hard",
        "explanation": "A null and void license can result from a license revocation or a failure to complete a post-licensing course."
    },
    {
        "id": 61,
        "question": "What is the penalty for a first-degree misdemeanor violation of Florida real estate law?",
        "answer": "A fine of up to $1,000 and up to one year in jail.",
        "category": "Violations and Penalties",
        "difficulty": "hard",
        "explanation": "This is a serious offense that can include unlicensed real estate activity."
    },
    {
        "id": 62,
        "question": "What is the purpose of the Florida Real Estate Recovery Fund?",
        "answer": "To reimburse a consumer for financial loss caused by a licensed real estate professional.",
        "category": "Licensing and Regulation",
        "difficulty": "easy",
        "explanation": "It's a way for consumers to recover damages if a licensee's misconduct causes them to lose money."
    },
    {
        "id": 63,
        "question": "What is a corporation 'not for profit' in real estate?",
        "answer": "A non-profit organization that can engage in real estate activities but cannot be registered as a real estate broker.",
        "category": "Business Structures",
        "difficulty": "medium",
        "explanation": "These entities are typically charitable organizations and are not licensed to handle general real estate brokerage business."
    },
    {
        "id": 64,
        "question": "What is a unilateral contract?",
        "answer": "A contract where one party makes a promise in exchange for an act by the other party.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "The most common example is a reward poster, where the offeror promises a reward for a specific action, and the other party is not obligated to act."
    },
    {
        "id": 65,
        "question": "What is a bilateral contract?",
        "answer": "A contract in which both parties make a promise to each other.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "A standard purchase and sale agreement is a bilateral contract because both the buyer and seller promise to perform."
    },
    {
        "id": 66,
        "question": "What is an express contract?",
        "answer": "A contract where the terms are stated clearly, either in writing or orally.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "The terms of an express contract are explicitly stated and agreed upon by both parties."
    },
    {
        "id": 67,
        "question": "What is an implied contract?",
        "answer": "A contract that is created by the actions of the parties involved, rather than by a written or verbal agreement.",
        "category": "Contract Types",
        "difficulty": "medium",
        "explanation": "For example, when you order food at a restaurant, it's an implied contract that you will pay for the meal after you eat it."
    },
    {
        "id": 68,
        "question": "What is an executory contract?",
        "answer": "A contract where one or both parties have not yet fulfilled their obligations.",
        "category": "Contract Status",
        "difficulty": "easy",
        "explanation": "A purchase and sale agreement is executory from the time it is signed until the closing is complete."
    },
    {
        "id": 69,
        "question": "What is an executed contract?",
        "answer": "A contract where all parties have fulfilled their obligations.",
        "category": "Contract Status",
        "difficulty": "easy",
        "explanation": "In a real estate transaction, a contract becomes executed once the closing is complete and the deed has been delivered."
    },
    {
        "id": 70,
        "question": "What does it mean for a contract to be 'valid'?",
        "answer": "A contract that is legally binding and enforceable, containing all essential elements.",
        "category": "Contract Validity",
        "difficulty": "easy",
        "explanation": "A valid contract has offer and acceptance, legal purpose, consideration, and competent parties."
    },
    {
        "id": 71,
        "question": "What does it mean for a contract to be 'void'?",
        "answer": "A contract that has no legal effect and cannot be enforced by law.",
        "category": "Contract Validity",
        "difficulty": "medium",
        "explanation": "A contract is void if it lacks a legal purpose, such as an agreement to perform an illegal act."
    },
    {
        "id": 72,
        "question": "What does it mean for a contract to be 'voidable'?",
        "answer": "A contract that is valid but can be voided by one or both parties.",
        "category": "Contract Validity",
        "difficulty": "medium",
        "explanation": "A contract signed by a minor is voidable by the minor but can be enforced against the adult party."
    },
    {
        "id": 73,
        "question": "What does it mean for a contract to be 'unenforceable'?",
        "answer": "A contract that may be valid but cannot be enforced by legal action, such as an oral agreement that should have been in writing.",
        "category": "Contract Validity",
        "difficulty": "medium",
        "explanation": "The Statute of Frauds requires certain contracts, like those involving real estate, to be in writing to be enforceable."
    },
    {
        "id": 74,
        "question": "What is 'consideration' in a contract?",
        "answer": "Something of value exchanged between the parties, such as money, goods, services, or a promise.",
        "category": "Contract Elements",
        "difficulty": "easy",
        "explanation": "Consideration is the mutual exchange that makes a contract binding."
    },
    {
        "id": 75,
        "question": "What are the essential elements of a valid real estate contract?",
        "answer": "Competent parties, mutual assent (offer and acceptance), legal purpose, consideration, and must be in writing.",
        "category": "Contract Elements",
        "difficulty": "hard",
        "explanation": "All five of these elements must be present for a real estate contract to be legally binding and enforceable."
    },
    {
        "id": 76,
        "question": "What is the Statute of Frauds?",
        "answer": "A law that requires certain types of contracts, including real estate contracts, to be in writing and signed to be enforceable.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "This law is designed to prevent fraud and disputes over oral agreements."
    },
    {
        "id": 77,
        "question": "What is a listing agreement?",
        "answer": "A contract between a property owner and a real estate broker to find a buyer or tenant for the property.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "The listing agreement authorizes the broker to market the property on the seller's behalf."
    },
    {
        "id": 78,
        "question": "What is an open listing?",
        "answer": "A non-exclusive listing where the owner can hire multiple brokers and can also sell the property themselves without owing a commission.",
        "category": "Listing Agreements",
        "difficulty": "medium",
        "explanation": "The broker who is the procuring cause of the sale is the only one who gets paid."
    },
    {
        "id": 79,
        "question": "What is an exclusive right-of-sale listing?",
        "answer": "A listing agreement where the broker earns a commission regardless of who sells the property.",
        "category": "Listing Agreements",
        "difficulty": "medium",
        "explanation": "This type of listing offers the most protection for the broker and is the most common form of listing agreement."
    },
    {
        "id": 80,
        "question": "What is an exclusive-agency listing?",
        "answer": "A listing where the broker is the exclusive agent, but the seller retains the right to sell the property themselves without paying a commission.",
        "category": "Listing Agreements",
        "difficulty": "hard",
        "explanation": "This is a less common type of listing that provides less security for the broker."
    },
    {
        "id": 81,
        "question": "What is an option contract?",
        "answer": "A unilateral contract where an owner gives a potential buyer the exclusive right to buy the property within a specific timeframe.",
        "category": "Contract Types",
        "difficulty": "hard",
        "explanation": "The buyer pays for the option and is not obligated to buy, but the seller is obligated to sell if the buyer exercises the option."
    },
    {
        "id": 82,
        "question": "What is a land contract (or contract for deed)?",
        "answer": "A contract where the seller retains legal title to the property while the buyer takes possession and makes payments.",
        "category": "Contract Types",
        "difficulty": "hard",
        "explanation": "Title transfers to the buyer only after all payments, as specified in the contract, have been made."
    },
    {
        "id": 83,
        "question": "What is a 'meeting of the minds'?",
        "answer": "A situation where all parties to a contract agree on the exact terms of the agreement.",
        "category": "Contract Elements",
        "difficulty": "easy",
        "explanation": "Also known as mutual assent, it's a critical element for a valid contract."
    },
    {
        "id": 84,
        "question": "What is an offer?",
        "answer": "A proposal made by one party (the offeror) to another (the offeree) to enter into a contract.",
        "category": "Contract Formation",
        "difficulty": "easy",
        "explanation": "An offer must be clear, definite, and communicated to the offeree."
    },
    {
        "id": 85,
        "question": "What is an acceptance?",
        "answer": "The unconditional agreement to the terms of an offer.",
        "category": "Contract Formation",
        "difficulty": "easy",
        "explanation": "Once an offer is accepted, a binding contract is formed."
    },
    {
        "id": 86,
        "question": "What is a counteroffer?",
        "answer": "A new offer made in response to an original offer, which terminates the original offer.",
        "category": "Contract Formation",
        "difficulty": "medium",
        "explanation": "Any change to the original offer's terms constitutes a counteroffer, not an acceptance."
    },
    {
        "id": 87,
        "question": "What is the Statute of Limitations?",
        "answer": "A law that sets the maximum time after an event that legal proceedings can be initiated.",
        "category": "Contract Law",
        "difficulty": "hard",
        "explanation": "In Florida, the statute of limitations for a written contract is five years, and for an oral contract is four years."
    },
    {
        "id": 88,
        "question": "What does it mean to 'assign' a contract?",
        "answer": "To transfer one's rights and duties under a contract to another party.",
        "category": "Contract Assignment",
        "difficulty": "medium",
        "explanation": "The assignor remains secondarily liable unless there is a novation."
    },
    {
        "id": 89,
        "question": "What is 'novation'?",
        "answer": "The substitution of a new contract for an old one, or the substitution of a new party for an old one, with the agreement of all parties.",
        "category": "Contract Termination",
        "difficulty": "hard",
        "explanation": "Novation releases the original party from liability, unlike an assignment."
    },
    {
        "id": 90,
        "question": "What is 'rescission' of a contract?",
        "answer": "The cancellation of a contract, restoring the parties to their pre-contractual position.",
        "category": "Contract Termination",
        "difficulty": "medium",
        "explanation": "Rescission can be voluntary by mutual agreement or ordered by a court."
    },
    {
        "id": 91,
        "question": "What is 'breach of contract'?",
        "answer": "The failure of a party to fulfill their obligations under a contract.",
        "category": "Breach of Contract",
        "difficulty": "easy",
        "explanation": "When a breach occurs, the non-breaching party can pursue a legal remedy."
    },
    {
        "id": 92,
        "question": "What is 'specific performance'?",
        "answer": "A legal remedy that forces the breaching party to fulfill the terms of the contract.",
        "category": "Breach of Contract",
        "difficulty": "medium",
        "explanation": "This is a common remedy in real estate because each property is considered unique."
    },
    {
        "id": 93,
        "question": "What is the difference between a material and a minor breach?",
        "answer": "A material breach is a failure to perform a fundamental part of the contract, while a minor breach is less significant.",
        "category": "Breach of Contract",
        "difficulty": "hard",
        "explanation": "A material breach gives the non-breaching party the right to terminate the contract."
    },
    {
        "id": 94,
        "question": "What is 'liquidated damages'?",
        "answer": "A pre-agreed-upon amount of money that a party must pay if they breach the contract.",
        "category": "Breach of Contract",
        "difficulty": "hard",
        "explanation": "In real estate, earnest money is often treated as liquidated damages if the buyer breaches the contract."
    },
    {
        "id": 95,
        "question": "What is a 'lease'?",
        "answer": "A contract transferring the right to use and possess a property for a specified period in exchange for rent.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "A lease is a bilateral contract between the landlord and the tenant."
    },
    {
        "id": 96,
        "question": "What are the essential elements of a valid lease agreement?",
        "answer": "Competent parties, description of the property, amount of rent, terms of the lease, and mutual agreement.",
        "category": "Contract Elements",
        "difficulty": "medium",
        "explanation": "While a lease of less than one year does not need to be in writing, it's best practice to always have a written agreement."
    },
    {
        "id": 97,
        "question": "What is a 'purchase and sale agreement'?",
        "answer": "A contract that outlines the terms of the transfer of property from a seller to a buyer.",
        "category": "Contract Types",
        "difficulty": "easy",
        "explanation": "This is the most critical document in a real estate transaction."
    },
    {
        "id": 98,
        "question": "What is the role of an 'addendum' to a contract?",
        "answer": "A document that adds new terms to a contract, which must be signed by all parties to be valid.",
        "category": "Contract Components",
        "difficulty": "easy",
        "explanation": "An addendum is used for things not covered in the original contract, such as a contingency for a home inspection."
    },
    {
        "id": 99,
        "question": "What is the role of a 'rider' in a contract?",
        "answer": "An attachment that modifies or amends an existing contract.",
        "category": "Contract Components",
        "difficulty": "medium",
        "explanation": "Riders are similar to addenda and are used to include additional conditions to a contract."
    },
    {
        "id": 100,
        "question": "What is a 'contingency clause'?",
        "answer": "A provision in a contract that makes the contract's validity dependent on the occurrence of a certain event.",
        "category": "Contract Components",
        "difficulty": "medium",
        "explanation": "Common contingencies include a financing contingency or a satisfactory home inspection."
    },
    {
        "id": 101,
        "question": "What happens to the contract if a contingency is not met?",
        "answer": "The non-breaching party can terminate the contract and receive their earnest money deposit back.",
        "category": "Contract Termination",
        "difficulty": "medium",
        "explanation": "For example, if the buyer cannot get a mortgage, they can terminate the contract due to the financing contingency."
    },
    {
        "id": 102,
        "question": "What is 'earnest money'?",
        "answer": "A deposit made by a buyer to demonstrate their good faith and serious intent to purchase a property.",
        "category": "Contract Components",
        "difficulty": "easy",
        "explanation": "Earnest money is held in an escrow account and is applied toward the purchase price at closing."
    },
    {
        "id": 103,
        "question": "When can a party terminate a contract for 'impossibility of performance'?",
        "answer": "When it becomes impossible to perform the contract due to an unforeseen event, such as the property being destroyed.",
        "category": "Contract Termination",
        "difficulty": "hard",
        "explanation": "The impossibility must be objective, not just an inconvenience for one of the parties."
    },
    {
        "id": 104,
        "question": "What is a 'waiver' in a contract?",
        "answer": "The voluntary surrender of a known right.",
        "category": "Contract Components",
        "difficulty": "medium",
        "explanation": "For example, a buyer might waive the right to a home inspection if they are buying the property 'as-is'."
    },
    {
        "id": 105,
        "question": "What is the legal remedy of 'specific performance'?",
        "answer": "A court order compelling the breaching party to carry out the terms of the contract.",
        "category": "Breach of Contract",
        "difficulty": "medium",
        "explanation": "Specific performance is a common remedy for a buyer when a seller refuses to close on a real estate transaction."
    },
    {
        "id": 106,
        "question": "What is the 'time is of the essence' clause?",
        "answer": "A clause that makes contract deadlines strict and enforceable.",
        "category": "Contract Components",
        "difficulty": "hard",
        "explanation": "If a contract has this clause, failure to meet a deadline can result in a breach of contract."
    },
    {
        "id": 107,
        "question": "What is a binder agreement?",
        "answer": "A preliminary agreement that shows a buyer's serious intent to purchase a property before a full contract is drafted.",
        "category": "Contract Types",
        "difficulty": "medium",
        "explanation": "Binders are not full contracts and are often used to hold a property off the market for a short period."
    },
    {
        "id": 108,
        "question": "What is the difference between a voidable contract and an unenforceable contract?",
        "answer": "A voidable contract is valid until one party voids it, while an unenforceable contract cannot be enforced by a court from the beginning.",
        "category": "Contract Validity",
        "difficulty": "hard",
        "explanation": "An unenforceable contract often violates the Statute of Frauds."
    },
    {
        "id": 109,
        "question": "What does a contract's 'legal purpose' mean?",
        "answer": "The contract must be for a lawful reason and not be against public policy.",
        "category": "Contract Elements",
        "difficulty": "easy",
        "explanation": "A contract to buy and sell illegal drugs would be void because it lacks a legal purpose."
    },
    {
        "id": 110,
        "question": "What is 'competent parties' in a contract?",
        "answer": "Parties who are of legal age, mentally sound, and not under the influence of drugs or alcohol.",
        "category": "Contract Elements",
        "difficulty": "easy",
        "explanation": "A contract with a minor or a person with a severe mental disability is voidable."
    },
    {
        "id": 111,
        "question": "What is an 'amendment' to a contract?",
        "answer": "A document that changes or modifies one or more of the original terms of a contract, with the agreement of all parties.",
        "category": "Contract Components",
        "difficulty": "medium",
        "explanation": "An amendment changes an existing part of a contract, while an addendum adds new terms."
    },
    {
        "id": 112,
        "question": "What is a 'power of attorney'?",
        "answer": "A legal document that grants one person the authority to act on behalf of another person.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "A power of attorney can be used to sign a contract on behalf of an absent party."
    },
    {
        "id": 113,
        "question": "What is 'fraud' in a real estate contract?",
        "answer": "A misrepresentation or concealment of a material fact made with the intent to deceive.",
        "category": "Contract Law",
        "difficulty": "hard",
        "explanation": "Fraud can make a contract voidable by the party who was deceived."
    },
    {
        "id": 114,
        "question": "What is 'mistake of fact' in a contract?",
        "answer": "A misunderstanding by one or both parties regarding a material fact of the contract.",
        "category": "Contract Law",
        "difficulty": "hard",
        "explanation": "If the mistake is mutual and material, it can make the contract voidable."
    },
    {
        "id": 115,
        "question": "What is 'duress' in a contract?",
        "answer": "The use of threats or force to compel a person to sign a contract against their will.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "A contract signed under duress is voidable by the victim."
    },
    {
        "id": 116,
        "question": "What is 'undue influence' in a contract?",
        "answer": "Taking advantage of a position of trust or authority to persuade a person to sign a contract.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "Undue influence can make a contract voidable."
    },
    {
        "id": 117,
        "question": "What is 'parol evidence rule'?",
        "answer": "A rule that prohibits introducing oral evidence in court to contradict the terms of a written contract.",
        "category": "Contract Law",
        "difficulty": "hard",
        "explanation": "This rule reinforces the importance of putting all terms in writing."
    },
    {
        "id": 118,
        "question": "What is an 'option fee'?",
        "answer": "The non-refundable fee paid by the potential buyer for an option contract.",
        "category": "Contract Components",
        "difficulty": "medium",
        "explanation": "The fee gives the buyer the right to buy, but not the obligation."
    },
    {
        "id": 119,
        "question": "What is a 'contract for deed'?",
        "answer": "A contract where the seller holds title until the buyer pays the full purchase price.",
        "category": "Contract Types",
        "difficulty": "hard",
        "explanation": "The buyer gets equitable title but not legal title until all payments are made."
    },
    {
        "id": 120,
        "question": "What is a 'lease with an option to purchase'?",
        "answer": "A lease agreement that gives the tenant the right to purchase the property at a predetermined price during the lease term.",
        "category": "Contract Types",
        "difficulty": "hard",
        "explanation": "A portion of the rent may be applied toward the purchase price."
    },
    {
        "id": 121,
        "question": "What is 'reformation'?",
        "answer": "A legal remedy that allows a court to rewrite a contract to correct a mistake and reflect the true intentions of the parties.",
        "category": "Breach of Contract",
        "difficulty": "hard",
        "explanation": "This remedy is used when the contract does not accurately reflect what the parties agreed to."
    },
    {
        "id": 122,
        "question": "What is 'ratification'?",
        "answer": "The subsequent approval or adoption of a contract or act that was not originally binding.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "A minor, upon reaching the age of majority, can ratify a contract they signed while a minor."
    },
    {
        "id": 123,
        "question": "What is 'performance' in a contract?",
        "answer": "The fulfillment of one's obligations under the contract.",
        "category": "Contract Status",
        "difficulty": "easy",
        "explanation": "Once both parties have performed, the contract is executed."
    },
    {
        "id": 124,
        "question": "What is the difference between a purchase and sale agreement and an option contract?",
        "answer": "A purchase and sale agreement is a binding, bilateral contract, while an option is a unilateral contract that a buyer may or may not exercise.",
        "category": "Contract Types",
        "difficulty": "hard",
        "explanation": "An option gives the buyer the choice to buy, while a purchase agreement obligates them to buy."
    },
    {
        "id": 125,
        "question": "What happens if a contract is vague or ambiguous?",
        "answer": "A court will generally interpret the contract against the party who drafted it.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "This is known as the rule of 'contra proferentem'."
    },
    {
        "id": 126,
        "question": "What is a 'statute of limitations' for a written contract in Florida?",
        "answer": "Five years from the date of the breach.",
        "category": "Contract Law",
        "difficulty": "medium",
        "explanation": "For an oral contract, the statute of limitations is four years."
    },
    {
        "id": 127,
        "question": "What is a conventional mortgage?",
        "answer": "A loan that is not insured or guaranteed by a government agency like the FHA or VA.",
        "category": "Mortgage Types",
        "difficulty": "easy",
        "explanation": "Conventional loans are the most common type of mortgage and are based on the borrower's credit history and financial stability."
    },
    {
        "id": 128,
        "question": "What is a FHA-insured loan?",
        "answer": "A loan insured by the Federal Housing Administration, designed to help low-to-moderate-income borrowers purchase homes.",
        "category": "Government Loans",
        "difficulty": "easy",
        "explanation": "FHA loans have less stringent credit and down payment requirements than conventional loans."
    },
    {
        "id": 129,
        "question": "What is a VA-guaranteed loan?",
        "answer": "A loan guaranteed by the Department of Veterans Affairs for eligible veterans, service members, and their spouses.",
        "category": "Government Loans",
        "difficulty": "easy",
        "explanation": "VA loans often require no down payment and have no private mortgage insurance requirement."
    },
    {
        "id": 130,
        "question": "What is a Mortgagee?",
        "answer": "The lender in a mortgage transaction.",
        "category": "Mortgage Terminology",
        "difficulty": "easy",
        "explanation": "The 'ee' at the end of the word often indicates the recipient of a benefit or right."
    },
    {
        "id": 131,
        "question": "What is a Mortgagor?",
        "answer": "The borrower in a mortgage transaction.",
        "category": "Mortgage Terminology",
        "difficulty": "easy",
        "explanation": "The 'or' at the end of the word often indicates the one who gives or performs an action."
    },
    {
        "id": 132,
        "question": "What is private mortgage insurance (PMI)?",
        "answer": "An insurance policy that protects the lender from a loss if the borrower defaults on a conventional loan with a low down payment.",
        "category": "Mortgage Insurance",
        "difficulty": "medium",
        "explanation": "PMI is typically required for conventional loans when the borrower puts less than 20% down."
    },
    {
        "id": 133,
        "question": "What is the primary purpose of a mortgage?",
        "answer": "To secure a promissory note and provide the lender with a lien on the property.",
        "category": "Mortgage Fundamentals",
        "difficulty": "easy",
        "explanation": "The mortgage is the document that creates a lien; the promissory note is the promise to repay the loan."
    },
    {
        "id": 134,
        "question": "What is a promissory note?",
        "answer": "A legal document that serves as a borrower's promise to repay a debt according to specified terms.",
        "category": "Mortgage Fundamentals",
        "difficulty": "easy",
        "explanation": "The promissory note is the promise to pay; the mortgage is the security for that promise."
    },
    {
        "id": 135,
        "question": "What is an amortization schedule?",
        "answer": "A table that shows the gradual repayment of a loan, including the breakdown of each payment into principal and interest.",
        "category": "Mortgage Terminology",
        "difficulty": "medium",
        "explanation": "Early payments on an amortized loan consist of a higher percentage of interest than later payments."
    },
    {
        "id": 136,
        "question": "What is a fully amortized loan?",
        "answer": "A loan where each payment is the same, with the principal being paid down over the life of the loan until the balance is zero.",
        "category": "Loan Types",
        "difficulty": "easy",
        "explanation": "Most residential mortgages are fully amortized loans."
    },
    {
        "id": 137,
        "question": "What is a partially amortized loan?",
        "answer": "A loan with payments that are not sufficient to fully pay off the loan balance by the end of the term, leaving a balloon payment.",
        "category": "Loan Types",
        "difficulty": "medium",
        "explanation": "The final payment is a large 'balloon' payment that pays off the remaining principal."
    },
    {
        "id": 138,
        "question": "What is a balloon payment?",
        "answer": "A large, single payment due at the end of a partially amortized loan term.",
        "category": "Loan Types",
        "difficulty": "easy",
        "explanation": "The monthly payments on a partially amortized loan are lower, but the final payment is substantial."
    },
    {
        "id": 139,
        "question": "What is a fixed-rate mortgage?",
        "answer": "A loan where the interest rate remains the same for the entire life of the loan.",
        "category": "Loan Types",
        "difficulty": "easy",
        "explanation": "Fixed-rate mortgages provide stability and predictability in a borrower's monthly payments."
    },
    {
        "id": 140,
        "question": "What is an adjustable-rate mortgage (ARM)?",
        "answer": "A loan where the interest rate fluctuates based on an economic index.",
        "category": "Loan Types",
        "difficulty": "easy",
        "explanation": "ARMs typically have a lower initial interest rate but come with the risk of future payment increases."
    },
    {
        "id": 141,
        "question": "What is a margin in an ARM?",
        "answer": "A fixed percentage added to the index to determine the fully indexed interest rate.",
        "category": "Mortgage Terminology",
        "difficulty": "medium",
        "explanation": "The margin represents the lender's profit and remains constant throughout the life of the loan."
    },
    {
        "id": 142,
        "question": "What is an index in an ARM?",
        "answer": "An economic indicator used by the lender to calculate the interest rate on an adjustable-rate mortgage.",
        "category": "Mortgage Terminology",
        "difficulty": "medium",
        "explanation": "Common indices include the U.S. Treasury Bill or the LIBOR."
    },
    {
        "id": 143,
        "question": "What is a mortgage broker?",
        "answer": "An intermediary who connects borrowers with lenders and helps them find the best loan terms.",
        "category": "Financing Sources",
        "difficulty": "easy",
        "explanation": "Mortgage brokers do not lend money themselves; they act as a liaison."
    },
    {
        "id": 144,
        "question": "What is a mortgage banker?",
        "answer": "An entity that originates, funds, and services mortgage loans.",
        "category": "Financing Sources",
        "difficulty": "medium",
        "explanation": "Mortgage bankers use their own funds to close loans, then may sell them on the secondary market."
    },
    {
        "id": 145,
        "question": "What is the secondary mortgage market?",
        "answer": "The market where mortgage loans are bought and sold after being originated.",
        "category": "Mortgage Markets",
        "difficulty": "easy",
        "explanation": "Major players in this market include Fannie Mae, Freddie Mac, and Ginnie Mae."
    },
    {
        "id": 146,
        "question": "What is a conforming loan?",
        "answer": "A loan that meets the guidelines of Fannie Mae and Freddie Mac and can be sold on the secondary market.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "Conforming loans have specific loan limits and borrower requirements set by the government-sponsored enterprises."
    },
    {
        "id": 147,
        "question": "What is a non-conforming loan?",
        "answer": "A loan that does not meet the guidelines of Fannie Mae and Freddie Mac and cannot be sold on the secondary market.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "Jumbo loans, which exceed conforming loan limits, are a common example of non-conforming loans."
    },
    {
        "id": 148,
        "question": "What is the Equal Credit Opportunity Act (ECOA)?",
        "answer": "A federal law that prohibits discrimination in lending based on race, color, religion, national origin, sex, marital status, or age.",
        "category": "Federal Laws",
        "difficulty": "medium",
        "explanation": "ECOA ensures that all credit applicants are treated equally."
    },
    {
        "id": 149,
        "question": "What is the Truth in Lending Act (TILA)?",
        "answer": "A federal law that requires lenders to disclose all loan costs, including the annual percentage rate (APR).",
        "category": "Federal Laws",
        "difficulty": "medium",
        "explanation": "TILA's purpose is to promote the informed use of consumer credit."
    },
    {
        "id": 150,
        "question": "What is the Real Estate Settlement Procedures Act (RESPA)?",
        "answer": "A federal law that requires lenders to provide borrowers with information about closing costs and settlement procedures.",
        "category": "Federal Laws",
        "difficulty": "medium",
        "explanation": "RESPA prohibits kickbacks and unearned fees in real estate transactions."
    },
    {
        "id": 151,
        "question": "What is the term for a mortgage that covers two or more parcels of real estate?",
        "answer": "A blanket mortgage.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "This type of loan is often used by developers to finance a subdivision."
    },
    {
        "id": 152,
        "question": "What is a reverse annuity mortgage (RAM)?",
        "answer": "A loan for homeowners 62 or older that allows them to convert part of their home equity into cash.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "The loan does not have to be repaid until the borrower moves out, sells the home, or dies."
    },
    {
        "id": 153,
        "question": "What is a subprime mortgage?",
        "answer": "A mortgage offered to borrowers with a poor credit history, who would not qualify for a conventional loan.",
        "category": "Mortgage Types",
        "difficulty": "medium",
        "explanation": "Subprime loans typically have higher interest rates and fees to compensate for the increased risk."
    },
    {
        "id": 154,
        "question": "What is a due-on-sale clause?",
        "answer": "A clause in a mortgage that requires the borrower to pay the loan in full if the property is sold.",
        "category": "Mortgage Clauses",
        "difficulty": "hard",
        "explanation": "This clause prevents a buyer from assuming the seller's mortgage without the lender's consent."
    },
    {
        "id": 155,
        "question": "What is a prepayment penalty clause?",
        "answer": "A clause that requires the borrower to pay a penalty for paying off the mortgage before the end of the term.",
        "category": "Mortgage Clauses",
        "difficulty": "medium",
        "explanation": "Prepayment penalties are less common today but are still found in some loans."
    },
    {
        "id": 156,
        "question": "What is a defeasance clause?",
        "answer": "A clause in a mortgage that states the mortgage is void once the loan has been paid in full.",
        "category": "Mortgage Clauses",
        "difficulty": "hard",
        "explanation": "This clause is crucial for the borrower to receive a clear title after paying off the loan."
    },
    {
        "id": 157,
        "question": "What is a subordination clause?",
        "answer": "A clause that allows a lender to waive their priority of lien position in favor of a subsequent lender.",
        "category": "Mortgage Clauses",
        "difficulty": "hard",
        "explanation": "This is often used in second mortgages or for new construction loans."
    },
    {
        "id": 158,
        "question": "What is a novation?",
        "answer": "The substitution of a new contract or party in an existing mortgage agreement, releasing the original party from liability.",
        "category": "Mortgage Terminology",
        "difficulty": "hard",
        "explanation": "This is different from a loan assumption, where the original borrower remains liable if the new borrower defaults."
    },
    {
        "id": 159,
        "question": "What is a mortgage assumption?",
        "answer": "A situation where a new buyer takes on the responsibility of the seller's existing mortgage.",
        "category": "Mortgage Terminology",
        "difficulty": "medium",
        "explanation": "This can be beneficial if the existing mortgage has a lower interest rate, but it is rare with conventional loans."
    },
    {
        "id": 160,
        "question": "What is a purchase money mortgage?",
        "answer": "A mortgage where the seller finances all or part of the purchase price for the buyer.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "This is a form of seller financing and is also known as a 'seller-held mortgage'."
    },
    {
        "id": 161,
        "question": "What is a second mortgage (or home equity loan)?",
        "answer": "A mortgage taken out on a property that is already mortgaged, which has a subordinate lien position.",
        "category": "Mortgage Types",
        "difficulty": "medium",
        "explanation": "The second mortgage holder's claim on the property comes after the first mortgage holder's claim."
    },
    {
        "id": 162,
        "question": "What is a home equity line of credit (HELOC)?",
        "answer": "A revolving line of credit secured by the equity in a home.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "A HELOC functions like a credit card, allowing the borrower to draw funds as needed up to a certain limit."
    },
    {
        "id": 163,
        "question": "What is a straight-term mortgage?",
        "answer": "An interest-only mortgage where the borrower only pays the interest on the loan for a set period, with the principal due in a lump sum at the end.",
        "category": "Loan Types",
        "difficulty": "hard",
        "explanation": "This type of loan is risky because it requires a large final payment and does not build equity over time."
    },
    {
        "id": 164,
        "question": "What is an acceleration clause?",
        "answer": "A clause in a mortgage that allows the lender to demand the entire loan balance be paid immediately if the borrower defaults.",
        "category": "Mortgage Clauses",
        "difficulty": "hard",
        "explanation": "This clause gives the lender the right to 'accelerate' the loan's due date."
    },
    {
        "id": 165,
        "question": "What is a prepayment clause?",
        "answer": "A clause that gives a borrower the right to pay off their loan early.",
        "category": "Mortgage Clauses",
        "difficulty": "medium",
        "explanation": "This is the opposite of a prepayment penalty clause and is a benefit to the borrower."
    },
    {
        "id": 166,
        "question": "What is a discount point?",
        "answer": "A fee paid to a lender at closing to lower the interest rate of a loan.",
        "category": "Mortgage Terminology",
        "difficulty": "medium",
        "explanation": "One discount point is equal to 1% of the loan amount."
    },
    {
        "id": 167,
        "question": "What is a loan origination fee?",
        "answer": "A fee charged by a lender to process a new loan application.",
        "category": "Mortgage Terminology",
        "difficulty": "easy",
        "explanation": "This fee is typically a percentage of the loan amount."
    },
    {
        "id": 168,
        "question": "What is an estoppel certificate?",
        "answer": "A document signed by a tenant certifying the current lease terms and conditions for a buyer of the property.",
        "category": "Contract Law",
        "difficulty": "hard",
        "explanation": "This is used in multi-family or commercial real estate transactions to verify the lease details and protect the buyer."
    },
    {
        "id": 169,
        "question": "What is a deed of trust?",
        "answer": "A three-party instrument used to secure a loan, involving the borrower, the lender, and a trustee.",
        "category": "Mortgage Fundamentals",
        "difficulty": "hard",
        "explanation": "The trustee holds the title until the loan is paid off, at which point it is transferred to the borrower."
    },
    {
        "id": 170,
        "question": "What is a lien theory state?",
        "answer": "A state where the borrower holds legal title to the property and the lender holds a lien against it.",
        "category": "Mortgage Fundamentals",
        "difficulty": "medium",
        "explanation": "Florida is a lien theory state."
    },
    {
        "id": 171,
        "question": "What is a title theory state?",
        "answer": "A state where the lender holds legal title to the property until the loan is fully paid off.",
        "category": "Mortgage Fundamentals",
        "difficulty": "medium",
        "explanation": "In a title theory state, the borrower holds equitable title."
    },
    {
        "id": 172,
        "question": "What is a buydown mortgage?",
        "answer": "A mortgage where the interest rate is temporarily lowered in the first few years of the loan, with the difference paid for by the seller or builder.",
        "category": "Mortgage Types",
        "difficulty": "hard",
        "explanation": "This is often used as a sales incentive to make a property more affordable in the initial years."
    },
    {
        "id": 173,
        "question": "What is a reverse mortgage?",
        "answer": "A loan that allows homeowners 62 or older to borrow against their home equity, with the loan balance increasing over time.",
        "category": "Mortgage Types",
        "difficulty": "easy",
        "explanation": "The loan becomes due when the homeowner sells, moves out, or dies."
    },
    {
        "id": 174,
        "question": "What is 'real property'?",
        "answer": "Land and anything permanently attached to it, including buildings, trees, and fixtures.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "Real property is also known as real estate and is immovable."
    },
    {
        "id": 175,
        "question": "What is 'personal property'?",
        "answer": "Items that are not permanently attached to the land and are considered movable, also known as chattels.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "Examples include furniture, vehicles, and a television not mounted to a wall."
    },
    {
        "id": 176,
        "question": "What is a 'fixture'?",
        "answer": "An item that was once personal property but has been permanently attached to the real property, thus becoming part of it.",
        "category": "Property Rights",
        "difficulty": "medium",
        "explanation": "Fixtures are included in the sale of real estate unless otherwise specified in the contract."
    },
    {
        "id": 177,
        "question": "What is a 'trade fixture'?",
        "answer": "An item of personal property attached by a tenant for use in a trade or business.",
        "category": "Property Rights",
        "difficulty": "hard",
        "explanation": "Trade fixtures remain the tenant's personal property and can be removed at the end of the lease, unlike regular fixtures."
    },
    {
        "id": 178,
        "question": "What is a 'fee simple estate'?",
        "answer": "The most comprehensive form of ownership, providing the owner with the greatest bundle of rights.",
        "category": "Estates in Land",
        "difficulty": "easy",
        "explanation": "A fee simple owner has the right to possess, use, sell, and pass the property on to their heirs."
    },
    {
        "id": 179,
        "question": "What is a 'life estate'?",
        "answer": "An estate in real property that is held for the duration of the life of a designated person.",
        "category": "Estates in Land",
        "difficulty": "medium",
        "explanation": "The life tenant has the right to use the property, but cannot waste it or sell the fee simple title."
    },
    {
        "id": 180,
        "question": "What is a 'remainderman'?",
        "answer": "The person who will receive the property after a life estate terminates.",
        "category": "Estates in Land",
        "difficulty": "medium",
        "explanation": "The remainderman holds a future interest in the property."
    },
    {
        "id": 181,
        "question": "What is a 'tenancy in common'?",
        "answer": "A form of co-ownership where two or more people hold an undivided interest in the property, with no right of survivorship.",
        "category": "Co-Ownership",
        "difficulty": "easy",
        "explanation": "Each owner can sell or pass their interest on to their heirs without the consent of the other owners."
    },
    {
        "id": 182,
        "question": "What is a 'joint tenancy'?",
        "answer": "A form of co-ownership with the 'right of survivorship,' meaning a deceased owner's interest automatically passes to the surviving owners.",
        "category": "Co-Ownership",
        "difficulty": "medium",
        "explanation": "To create a joint tenancy, four unities must be present: possession, interest, time, and title."
    },
    {
        "id": 183,
        "question": "What are the four unities required for a joint tenancy?",
        "answer": "Possession, Interest, Time, and Title (PITT).",
        "category": "Co-Ownership",
        "difficulty": "hard",
        "explanation": "All four unities must be created at the same time and in the same document for a joint tenancy to exist."
    },
    {
        "id": 184,
        "question": "What is a 'tenancy by the entirety'?",
        "answer": "A form of co-ownership for married couples with a right of survivorship, which protects the property from the individual debts of either spouse.",
        "category": "Co-Ownership",
        "difficulty": "medium",
        "explanation": "This form of ownership is only available to a husband and wife."
    },
    {
        "id": 185,
        "question": "What is a 'condominium'?",
        "answer": "A form of ownership where each owner holds a fee simple title to their individual unit and a shared, undivided interest in the common areas.",
        "category": "Condominiums",
        "difficulty": "easy",
        "explanation": "Condominium ownership is created by recording a 'Declaration of Condominium' document."
    },
    {
        "id": 186,
        "question": "What is a 'cooperative' (co-op)?",
        "answer": "A form of ownership where a corporation holds title to the property and owners receive stock in the corporation and a proprietary lease for their unit.",
        "category": "Cooperatives",
        "difficulty": "medium",
        "explanation": "In a co-op, the owners do not own the real estate; they own shares in the corporation that owns the real estate."
    },
    {
        "id": 187,
        "question": "What is a 'proprietary lease'?",
        "answer": "A lease issued to a co-op shareholder that gives them the right to occupy a specific unit.",
        "category": "Cooperatives",
        "difficulty": "easy",
        "explanation": "This lease is the document that grants the right of possession to the co-op owner."
    },
    {
        "id": 188,
        "question": "What is a 'time-sharing'?",
        "answer": "A form of ownership that gives an owner the right to use a property for a specified period each year.",
        "category": "Time-Sharing",
        "difficulty": "easy",
        "explanation": "Time-sharing can be a form of either fee simple or leasehold ownership."
    },
    {
        "id": 189,
        "question": "What is a 'developer's public offering statement'?",
        "answer": "A document that outlines the details of a condominium, cooperative, or time-share development that must be given to all prospective buyers.",
        "category": "Property Rights",
        "difficulty": "medium",
        "explanation": "This document is required by Florida law to provide full disclosure to buyers."
    },
    {
        "id": 190,
        "question": "What is a 'community development district' (CDD)?",
        "answer": "A local, special-purpose government entity authorized to plan, finance, construct, and manage a master-planned community.",
        "category": "Property Rights",
        "difficulty": "hard",
        "explanation": "CDDs have the power to levy assessments and issue bonds to pay for community infrastructure."
    },
    {
        "id": 191,
        "question": "What is a 'homeowner association' (HOA)?",
        "answer": "A private association that governs a residential community and enforces rules and regulations.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "HOAs collect dues from residents to maintain common areas and provide services."
    },
    {
        "id": 192,
        "question": "What is an 'estate for years'?",
        "answer": "A leasehold estate with a definite start and end date.",
        "category": "Leasehold Estates",
        "difficulty": "easy",
        "explanation": "This estate does not require notice to terminate at the end of its term."
    },
    {
        "id": 193,
        "question": "What is a 'tenancy at will'?",
        "answer": "A leasehold estate that has no definite term and can be terminated by either party with proper notice.",
        "category": "Leasehold Estates",
        "difficulty": "medium",
        "explanation": "It is often created by an oral agreement."
    },
    {
        "id": 194,
        "question": "What is a 'tenancy at sufferance'?",
        "answer": "A leasehold estate where a tenant remains in possession of the property after their lease has expired without the landlord's consent.",
        "category": "Leasehold Estates",
        "difficulty": "medium",
        "explanation": "The tenant is a holdover tenant, and the landlord can evict them."
    },
    {
        "id": 195,
        "question": "What is a 'bundle of rights'?",
        "answer": "A set of legal rights associated with the ownership of real property, including the rights to possess, use, enjoy, exclude, and dispose of the property.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "These are the fundamental rights that a property owner holds."
    },
    {
        "id": 196,
        "question": "What is a 'right of survivorship'?",
        "answer": "The right of a surviving joint tenant or tenant by the entirety to inherit the property upon the death of the other co-owner.",
        "category": "Co-Ownership",
        "difficulty": "medium",
        "explanation": "This right overrides the terms of a will."
    },
    {
        "id": 197,
        "question": "What is a 'timeshare estate'?",
        "answer": "A form of time-sharing that gives the owner a fee simple interest in the property for a specific period each year.",
        "category": "Time-Sharing",
        "difficulty": "medium",
        "explanation": "The owner has a real property interest that can be sold or passed on to heirs."
    },
    {
        "id": 198,
        "question": "What is a 'timeshare use'?",
        "answer": "A form of time-sharing that gives the owner a leasehold interest in the property for a specific period each year.",
        "category": "Time-Sharing",
        "difficulty": "medium",
        "explanation": "This is a right to use the property, not an ownership interest in the real estate itself."
    },
    {
        "id": 199,
        "question": "What is the difference between a co-op and a condominium?",
        "answer": "In a co-op, an owner has a proprietary lease and stock in the corporation; in a condominium, an owner has a fee simple title to their unit.",
        "category": "Co-Ownership",
        "difficulty": "hard",
        "explanation": "The form of ownership and the legal documents that create the interest are the key differences."
    },
    {
        "id": 200,
        "question": "What is an 'estate in severalty'?",
        "answer": "Ownership of real property by a single individual.",
        "category": "Co-Ownership",
        "difficulty": "easy",
        "explanation": "The owner is the sole owner and has all the rights to the property."
    },
    {
        "id": 201,
        "question": "What is the primary document that creates a condominium?",
        "answer": "A Declaration of Condominium.",
        "category": "Condominiums",
        "difficulty": "medium",
        "explanation": "This document must be recorded in the public records of the county where the property is located."
    },
    {
        "id": 202,
        "question": "What is a condominium association?",
        "answer": "A non-profit organization responsible for the administration and maintenance of a condominium.",
        "category": "Condominiums",
        "difficulty": "easy",
        "explanation": "The association is governed by the condo's bylaws and board of directors."
    },
    {
        "id": 203,
        "question": "What is a 'common element' in a condominium?",
        "answer": "The portions of the condominium property not included in the individual units, such as the hallways, pools, and elevators.",
        "category": "Condominiums",
        "difficulty": "easy",
        "explanation": "All unit owners have an undivided interest in the common elements."
    },
    {
        "id": 204,
        "question": "What is a 'limited common element'?",
        "answer": "A common element reserved for the exclusive use of one or more specified units.",
        "category": "Condominiums",
        "difficulty": "medium",
        "explanation": "Examples include a balcony or a parking space assigned to a specific unit."
    },
    {
        "id": 205,
        "question": "What is an 'easement'?",
        "answer": "The right to use the land of another for a specific purpose.",
        "category": "Encumbrances",
        "difficulty": "medium",
        "explanation": "Common easements include a right-of-way for a driveway or utility access."
    },
    {
        "id": 206,
        "question": "What is a 'lien'?",
        "answer": "A legal claim or charge against a property as security for a debt or obligation.",
        "category": "Encumbrances",
        "difficulty": "easy",
        "explanation": "A mortgage is a type of voluntary lien; a property tax lien is an involuntary lien."
    },
    {
        "id": 207,
        "question": "What is a 'license'?",
        "answer": "A personal, revocable, and non-assignable right to use the property of another.",
        "category": "Encumbrances",
        "difficulty": "medium",
        "explanation": "A license is not an estate in land; it is a temporary permission, such as a ticket to a concert."
    },
    {
        "id": 208,
        "question": "What is a 'tenancy in partnership'?",
        "answer": "A form of co-ownership for partners in a business, where each partner has a right to use the property for partnership purposes.",
        "category": "Co-Ownership",
        "difficulty": "hard",
        "explanation": "The property can only be conveyed with the consent of all partners."
    },
    {
        "id": 209,
        "question": "What is a 'homestead' in Florida law?",
        "answer": "A legal status that provides a tax exemption and protection from forced sale to a homeowner's primary residence.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "The purpose of homestead is to protect a family's home from creditors."
    },
    {
        "id": 210,
        "question": "What is the difference between a fee simple estate and a life estate?",
        "answer": "A fee simple estate is of indefinite duration and can be passed to heirs, while a life estate is for a limited duration of a person's life.",
        "category": "Estates in Land",
        "difficulty": "medium",
        "explanation": "The life tenant's ownership is temporary, while a fee simple owner's is permanent."
    },
    {
        "id": 211,
        "question": "What is a 'deed restriction'?",
        "answer": "A private restriction on the use of real property, typically found in the deed or a separate declaration.",
        "category": "Encumbrances",
        "difficulty": "medium",
        "explanation": "Deed restrictions are often used by developers to maintain the value and character of a subdivision."
    },
    {
        "id": 212,
        "question": "What is 'escheat'?",
        "answer": "The right of the state to take ownership of a property when an owner dies without a will and without any heirs.",
        "category": "Property Rights",
        "difficulty": "hard",
        "explanation": "This is a form of involuntary transfer of ownership to the state."
    },
    {
        "id": 213,
        "question": "What is 'police power'?",
        "answer": "The government's right to enact laws and regulations to protect the public health, safety, and welfare.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "Zoning ordinances and building codes are common examples of police power."
    },
    {
        "id": 214,
        "question": "What is 'eminent domain'?",
        "answer": "The government's right to take private property for public use, with just compensation to the owner.",
        "category": "Property Rights",
        "difficulty": "easy",
        "explanation": "This power is granted by the Fifth Amendment to the U.S. Constitution."
    },
    {
        "id": 215,
        "question": "What is 'adverse possession'?",
        "answer": "A method of acquiring title to another's property by using it in a way that is open, notorious, hostile, and continuous for a statutory period.",
        "category": "Property Rights",
        "difficulty": "hard",
        "explanation": "Adverse possession is a legally recognized way to gain title to land without a deed."
    },
    {
        "id": 216,
        "question": "What is 'real estate appraisal'?",
        "answer": "The process of developing a professional opinion of a property's market value.",
        "category": "Appraisal Fundamentals",
        "difficulty": "easy",
        "explanation": "Appraisals are performed by a licensed appraiser and are a required part of most mortgage lending processes."
    },
    {
        "id": 217,
        "question": "What is 'market value'?",
        "answer": "The most probable price a property will sell for in a competitive market, with a knowledgeable buyer and seller acting in their best interests.",
        "category": "Appraisal Terminology",
        "difficulty": "easy",
        "explanation": "Market value is an estimate of a property's worth, not the actual sales price."
    },
    {
        "id": 218,
        "question": "What is 'price' in real estate appraisal?",
        "answer": "The actual amount of money a buyer pays for a property.",
        "category": "Appraisal Terminology",
        "difficulty": "easy",
        "explanation": "Price and value are often different, as the price may be influenced by financing or other factors."
    },
    {
        "id": 219,
        "question": "What is 'cost' in real estate appraisal?",
        "answer": "The total amount of money required to produce a property, including land, materials, labor, and overhead.",
        "category": "Appraisal Terminology",
        "difficulty": "easy",
        "explanation": "Cost does not always equal a property's value."
    },
    {
        "id": 220,
        "question": "What is the 'principle of substitution'?",
        "answer": "The principle that a buyer will pay no more for a property than the cost of an equally desirable substitute.",
        "category": "Principles of Value",
        "difficulty": "medium",
        "explanation": "This principle is the basis for the sales comparison approach to value."
    },
    {
        "id": 221,
        "question": "What is the 'principle of contribution'?",
        "answer": "The principle that the value of an improvement is measured by its contribution to the overall value of the property.",
        "category": "Principles of Value",
        "difficulty": "medium",
        "explanation": "For example, a new pool's value is not its cost, but how much it increases the property's market value."
    },
    {
        "id": 222,
        "question": "What is the 'principle of conformity'?",
        "answer": "The principle that a property's value is maximized when it is in harmony with its surroundings.",
        "category": "Principles of Value",
        "difficulty": "easy",
        "explanation": "A house that is significantly overbuilt for its neighborhood may suffer from the principle of regression."
    },
    {
        "id": 223,
        "question": "What is the 'principle of progression'?",
        "answer": "The principle that a lower-value property's value is increased by the presence of higher-value properties in the same area.",
        "category": "Principles of Value",
        "difficulty": "easy",
        "explanation": "This is the opposite of the principle of regression."
    },
    {
        "id": 224,
        "question": "What is the 'principle of regression'?",
        "answer": "The principle that a higher-value property's value is negatively affected by the presence of lower-value properties in the same area.",
        "category": "Principles of Value",
        "difficulty": "easy",
        "explanation": "A mansion in a neighborhood of small homes will likely not sell for its true market value."
    },
    {
        "id": 225,
        "question": "What are the three approaches to real estate appraisal?",
        "answer": "The Sales Comparison Approach, the Cost Approach, and the Income Capitalization Approach.",
        "category": "Appraisal Methods",
        "difficulty": "easy",
        "explanation": "A licensed appraiser will often use all three approaches and then reconcile the results to determine a final value."
    },
    {
        "id": 226,
        "question": "What is the Sales Comparison Approach?",
        "answer": "An appraisal method that estimates value by comparing the subject property to similar, recently sold properties (comparables).",
        "category": "Appraisal Methods",
        "difficulty": "easy",
        "explanation": "This is the most common method for residential appraisals."
    },
    {
        "id": 227,
        "question": "What is the 'subject property'?",
        "answer": "The property that is being appraised.",
        "category": "Appraisal Terminology",
        "difficulty": "easy",
        "explanation": "The subject property is the focus of the appraisal report."
    },
    {
        "id": 228,
        "question": "What are 'comparables' (comps)?",
        "answer": "Recently sold properties that are similar to the subject property in location, size, age, and condition.",
        "category": "Appraisal Terminology",
        "difficulty": "easy",
        "explanation": "Appraisers typically use at least three comps to determine the value of a subject property."
    },
    {
        "id": 229,
        "question": "What is the process of making adjustments in the Sales Comparison Approach?",
        "answer": "Adjustments are made to the comparable properties' prices to account for differences from the subject property.",
        "category": "Appraisal Methods",
        "difficulty": "medium",
        "explanation": "The appraiser adjusts the comparable properties' prices to make them more like the subject property; if the comparable is better, you subtract value, and if it is worse, you add value."
    },
    {
        "id": 230,
        "question": "What is the Cost Approach?",
        "answer": "An appraisal method that estimates value based on the cost to rebuild or replace the property, minus any depreciation.",
        "category": "Appraisal Methods",
        "difficulty": "medium",
        "explanation": "This approach is most effective for new construction or special-purpose properties like schools or churches."
    },
    {
        "id": 231,
        "question": "What is 'accrued depreciation'?",
        "answer": "The total loss in value from all causes, including physical deterioration, functional obsolescence, and economic obsolescence.",
        "category": "Appraisal Terminology",
        "difficulty": "medium",
        "explanation": "This is a key component of the Cost Approach."
    },
    {
        "id": 232,
        "question": "What is 'physical deterioration'?",
        "answer": "A form of depreciation caused by the normal wear and tear of a building.",
        "category": "Depreciation",
        "difficulty": "easy",
        "explanation": "Examples include a leaky roof or worn-out carpet."
    },
    {
        "id": 233,
        "question": "What is 'functional obsolescence'?",
        "answer": "A form of depreciation caused by a property's outdated design or features that no longer meet modern standards.",
        "category": "Depreciation",
        "difficulty": "medium",
        "explanation": "Examples include a home with a one-car garage in a neighborhood of two-car garages or an outdated kitchen."
    },
    {
        "id": 234,
        "question": "What is 'economic obsolescence'?",
        "answer": "A form of depreciation caused by factors outside the property lines, such as a busy highway being built nearby or a change in zoning.",
        "category": "Depreciation",
        "difficulty": "hard",
        "explanation": "This is the only form of depreciation that is incurable."
    },
    {
        "id": 235,
        "question": "What is the Income Capitalization Approach?",
        "answer": "An appraisal method that estimates the value of a property based on its ability to generate income.",
        "category": "Appraisal Methods",
        "difficulty": "easy",
        "explanation": "This approach is primarily used for income-producing properties like apartment buildings or commercial spaces."
    },
    {
        "id": 236,
        "question": "What is 'capitalization rate'?",
        "answer": "The rate of return an investor expects to earn on a property, used in the income capitalization approach.",
        "category": "Appraisal Terminology",
        "difficulty": "medium",
        "explanation": "The formula is Net Operating Income (NOI) divided by the Capitalization Rate (Cap Rate) equals the Value."
    },
    {
        "id": 237,
        "question": "What is 'Net Operating Income' (NOI)?",
        "answer": "The income a property generates after deducting all operating expenses, but before deducting debt service or taxes.",
        "category": "Appraisal Terminology",
        "difficulty": "medium",
        "explanation": "NOI is the key metric used in the income capitalization approach."
    },
    {
        "id": 238,
        "question": "What is a 'gross rent multiplier' (GRM)?",
        "answer": "A simple way to estimate value for residential rental properties by dividing the sales price by the gross monthly rent.",
        "category": "Appraisal Methods",
        "difficulty": "hard",
        "explanation": "The GRM is a quick way to compare similar properties but is not as accurate as the income capitalization approach."
    },
    {
        "id": 239,
        "question": "What is a 'gross income multiplier' (GIM)?",
        "answer": "A method used for commercial properties by dividing the sales price by the gross annual income.",
        "category": "Appraisal Methods",
        "difficulty": "hard",
        "explanation": "The GIM is a simplified version of the income capitalization approach."
    },
    {
        "id": 240,
        "question": "What is the principle of highest and best use?",
        "answer": "The most profitable and legal use of a property, which provides the greatest value.",
        "category": "Principles of Value",
        "difficulty": "medium",
        "explanation": "An appraiser must determine the highest and best use to properly value a property."
    },
    {
        "id": 241,
        "question": "What is a 'comparative market analysis' (CMA)?",
        "answer": "A report prepared by a real estate agent to estimate a property's value based on recent sales in the area.",
        "category": "Valuation Tools",
        "difficulty": "easy",
        "explanation": "A CMA is not an appraisal; it is a tool for agents to help sellers price their homes."
    },
    {
        "id": 242,
        "question": "What is a 'broker's price opinion' (BPO)?",
        "answer": "A written estimate of a property's value by a real estate broker, often used for foreclosures or short sales.",
        "category": "Valuation Tools",
        "difficulty": "easy",
        "explanation": "Like a CMA, a BPO is not an appraisal and should not be used in place of one."
    },
    {
        "id": 243,
        "question": "What is the difference between a CMA and an appraisal?",
        "answer": "A CMA is an informal valuation by a real estate agent; an appraisal is a formal, professional opinion of value by a licensed appraiser.",
        "category": "Valuation Tools",
        "difficulty": "medium",
        "explanation": "An appraisal is required by lenders and is a more comprehensive report."
    },
    {
        "id": 244,
        "question": "What is 'over-improvement'?",
        "answer": "An improvement to a property that is more expensive or elaborate than is justified by the property's value or location.",
        "category": "Appraisal Terminology",
        "difficulty": "medium",
        "explanation": "An over-improvement may not add to the property's market value due to the principle of regression."
    },
    {
        "id": 245,
        "question": "What is the 'reconciliation' phase of an appraisal?",
        "answer": "The final step where the appraiser weighs the results from the three approaches to value and arrives at a final value opinion.",
        "category": "Appraisal Process",
        "difficulty": "hard",
        "explanation": "The appraiser does not average the three values, but rather gives more weight to the most appropriate approach for the property type."
    },
    {
        "id": 246,
        "question": "What is the purpose of the 'Uniform Standards of Professional Appraisal Practice' (USPAP)?",
        "answer": "To set the ethical and performance standards for all professional appraisers in the United States.",
        "category": "Appraisal Regulation",
        "difficulty": "hard",
        "explanation": "All licensed appraisers must follow USPAP to ensure the integrity of the appraisal process."
    },
    {
        "id": 247,
        "question": "What is a 'narrative appraisal report'?",
        "answer": "The most detailed and comprehensive appraisal report, often used for complex commercial properties.",
        "category": "Appraisal Reports",
        "difficulty": "hard",
        "explanation": "This type of report includes an extensive explanation of all the data and analysis used to determine value."
    },
    {
        "id": 248,
        "question": "What is a 'drive-by appraisal'?",
        "answer": "An appraisal where the appraiser only views the property from the street and does not go inside.",
        "category": "Appraisal Reports",
        "difficulty": "medium",
        "explanation": "These appraisals are typically used for low-risk loans or for existing properties with a history of good condition."
    },
    {
        "id": 249,
        "question": "What is 'replacement cost'?",
        "answer": "The cost of building a new structure that is functionally equivalent to the original, but using modern materials and construction methods.",
        "category": "Cost Approach",
        "difficulty": "medium",
        "explanation": "Replacement cost is the more common method used in the cost approach."
    },
    {
        "id": 250,
        "question": "What is 'reproduction cost'?",
        "answer": "The cost of building an exact replica of the original structure, using the same materials and design.",
        "category": "Cost Approach",
        "difficulty": "hard",
        "explanation": "This method is used for unique, historic, or custom-built properties."
    },
    {
        "id": 251,
        "question": "What is a 'gross rent multiplier'?",
        "answer": "A simplified valuation method for residential income properties.",
        "category": "Appraisal Methods",
        "difficulty": "easy",
        "explanation": "It's calculated by dividing the property's sales price by its monthly gross rent."
    },
    {
        "id": 252,
        "question": "What is the concept of 'highest and best use'?",
        "answer": "The most profitable legal use of a property, even if it is not its current use.",
        "category": "Appraisal Principles",
        "difficulty": "medium",
        "explanation": "For example, a residential lot in a commercial zone may have a higher value if a commercial building were built on it."
    },
    {
        "id": 253,
        "question": "What is the principle of 'anticipation'?",
        "answer": "Value is created by the expectation of future benefits.",
        "category": "Appraisal Principles",
        "difficulty": "hard",
        "explanation": "This principle is the basis for the income capitalization approach, as investors buy a property based on its expected future income."
    },
    {
        "id": 254,
        "question": "What is a 'comparative market analysis'?",
        "answer": "An analysis of the selling prices of comparable properties to determine a suggested price for a new listing.",
        "category": "Appraisal Tools",
        "difficulty": "easy",
        "explanation": "It is not a formal appraisal and cannot be used for a mortgage."
    },
    {
        "id": 255,
        "question": "What is a 'reconciliation of value'?",
        "answer": "The final step in the appraisal process where an appraiser weighs the different valuation methods to arrive at a final opinion of value.",
        "category": "Appraisal Process",
        "difficulty": "hard",
        "explanation": "The appraiser does not simply average the values from the different approaches but uses their professional judgment to determine which is most relevant."
    },
    {
        "id": 256,
        "question": "What is 'functional obsolescence'?",
        "answer": "A loss in value due to a property's features that are outdated or inefficient for its intended use.",
        "category": "Depreciation",
        "difficulty": "medium",
        "explanation": "Examples include a home with a poor floor plan or an inadequate number of bathrooms for its size."
    },
    {
        "id": 257,
        "question": "What is the 'gross rent multiplier' used for?",
        "answer": "To quickly estimate the value of residential rental properties.",
        "category": "Appraisal Methods",
        "difficulty": "easy",
        "explanation": "It's a simplified valuation tool that is not as accurate as the income capitalization approach."
    },
    {
        "id": 258,
        "question": "What are the three types of brokerage relationships in Florida?",
        "answer": "Transaction broker, single agent, and no brokerage relationship.",
        "category": "Brokerage Relationships",
        "difficulty": "easy",
        "explanation": "Florida law defines these three relationships as the only legal options for real estate professionals."
    },
    {
        "id": 259,
        "question": "What is the default brokerage relationship in Florida?",
        "answer": "Transaction broker.",
        "category": "Brokerage Relationships",
        "difficulty": "easy",
        "explanation": "Unless a single agent or no brokerage relationship is established in writing, all licensees operate as transaction brokers."
    },
    {
        "id": 260,
        "question": "What are the duties of a transaction broker?",
        "answer": "Honesty and fair dealing, accounting for all funds, limited confidentiality, and disclosing all known facts that materially affect the property's value.",
        "category": "Transaction Broker",
        "difficulty": "medium",
        "explanation": "A transaction broker is a facilitator who provides limited representation to both parties in a transaction."
    },
    {
        "id": 261,
        "question": "What is the primary difference between a transaction broker and a single agent?",
        "answer": "A transaction broker provides limited representation to both parties, while a single agent provides full fiduciary duties to only one party.",
        "category": "Brokerage Relationships",
        "difficulty": "medium",
        "explanation": "A single agent has a much higher level of duty to their client, including loyalty and confidentiality."
    },
    {
        "id": 262,
        "question": "What is a 'single agent'?",
        "answer": "A broker who represents a buyer or a seller, but not both, with full fiduciary duties.",
        "category": "Single Agency",
        "difficulty": "easy",
        "explanation": "A single agent relationship must be created in a written agreement."
    },
    {
        "id": 263,
        "question": "What are the duties of a single agent?",
        "answer": "Confidentiality, obedience, loyalty, disclosure, accounting for funds, and skill, care, and diligence.",
        "category": "Single Agency",
        "difficulty": "hard",
        "explanation": "These duties are known as the 'COLDS' duties and represent the highest level of care a professional can provide."
    },
    {
        "id": 264,
        "question": "What is the duty of 'loyalty' for a single agent?",
        "answer": "To act in the best interest of the principal at all times.",
        "category": "Single Agency",
        "difficulty": "medium",
        "explanation": "This is a key fiduciary duty that a transaction broker does not have."
    },
    {
        "id": 265,
        "question": "What is the duty of 'confidentiality' for a single agent?",
        "answer": "To not disclose any information that could harm the client's bargaining position.",
        "category": "Single Agency",
        "difficulty": "medium",
        "explanation": "A single agent cannot reveal a buyer's willingness to pay more or a seller's motivation to sell quickly."
    },
    {
        "id": 266,
        "question": "What is a 'no brokerage relationship'?",
        "answer": "A relationship where a licensee works with a buyer or seller as a facilitator without providing any representation.",
        "category": "No Brokerage Relationship",
        "difficulty": "easy",
        "explanation": "In this relationship, the broker has limited duties and acts as a neutral third party."
    },
    {
        "id": 267,
        "question": "When is a written disclosure required for a single agent relationship?",
        "answer": "Before or at the time of entering into a listing agreement or a contract for representation.",
        "category": "Disclosures",
        "difficulty": "medium",
        "explanation": "This disclosure must be in writing and signed by the principal."
    },
    {
        "id": 268,
        "question": "What is required for a transaction broker disclosure?",
        "answer": "No written disclosure is required, but the relationship is presumed to exist unless a single agent relationship is created.",
        "category": "Disclosures",
        "difficulty": "easy",
        "explanation": "The lack of a written disclosure is a key characteristic of the transaction broker relationship."
    },
    {
        "id": 269,
        "question": "What is the disclosure requirement for a 'no brokerage relationship'?",
        "answer": "The broker must provide a written notice to the customer before showing property or entering into a contract for service.",
        "category": "Disclosures",
        "difficulty": "medium",
        "explanation": "This disclosure makes it clear that the broker is not representing the customer in any capacity."
    },
    {
        "id": 270,
        "question": "What is 'designated sales associate'?",
        "answer": "A sales associate who acts as a single agent for a buyer or seller in the same transaction as another designated sales associate, with the consent of both parties.",
        "category": "Brokerage Relationships",
        "difficulty": "hard",
        "explanation": "This is only permitted in non-residential transactions where the parties have assets of $1 million or more."
    },
    {
        "id": 271,
        "question": "When can a broker change from a single agent to a transaction broker?",
        "answer": "With the written consent of the principal.",
        "category": "Brokerage Relationships",
        "difficulty": "medium",
        "explanation": "This is a change in a fiduciary relationship and must be done with the client's knowledge and approval."
    },
    {
        "id": 272,
        "question": "What is 'dual agency' in Florida?",
        "answer": "An illegal brokerage relationship where a broker represents both the buyer and the seller in the same transaction as a single agent.",
        "category": "Brokerage Violations",
        "difficulty": "easy",
        "explanation": "Florida law prohibits dual agency because it's a conflict of interest that makes it impossible for the broker to provide full fiduciary duties to both parties."
    },
    {
        "id": 273,
        "question": "What is a 'fiduciary relationship'?",
        "answer": "A relationship of trust and confidence between a broker and a client, which requires the broker to act in the client's best interest.",
        "category": "Brokerage Relationships",
        "difficulty": "easy",
        "explanation": "This type of relationship exists in a single agency but not in a transaction broker or no brokerage relationship."
    },
    {
        "id": 274,
        "question": "What is the broker's duty to disclose known material facts?",
        "answer": "A duty to disclose all known facts that materially affect the value of the property and are not readily observable to the buyer.",
        "category": "Disclosures",
        "difficulty": "medium",
        "explanation": "This duty exists for both transaction brokers and single agents."
    },
    {
        "id": 275,
        "question": "What is the difference between an agent and a subagent?",
        "answer": "An agent is a person authorized to act on behalf of a principal; a subagent is an agent of an agent.",
        "category": "Agency",
        "difficulty": "medium",
        "explanation": "In a single agency relationship, the sales associate is a subagent to the broker, who is the agent to the principal."
    },
    {
        "id": 276,
        "question": "What is the legal term for a broker's duty to use 'skill, care, and diligence'?",
        "answer": "This is a fiduciary duty that requires the broker to act as a competent professional.",
        "category": "Single Agency",
        "difficulty": "easy",
        "explanation": "This duty ensures that the broker is using their expertise to benefit the client."
    },
    {
        "id": 277,
        "question": "What is the duty of 'accounting for all funds'?",
        "answer": "To properly handle and account for all money or property entrusted to the broker.",
        "category": "Brokerage Duties",
        "difficulty": "easy",
        "explanation": "This duty is universal to all brokerage relationships in Florida."
    },
    {
        "id": 278,
        "question": "What is the legal term for 'limited confidentiality'?",
        "answer": "This is a duty of a transaction broker to not reveal certain information that could harm the parties, but it does not extend to full confidentiality.",
        "category": "Transaction Broker",
        "difficulty": "medium",
        "explanation": "A transaction broker can disclose a party's willingness to accept a different price unless they have written permission not to."
    },
    {
        "id": 279,
        "question": "What is the purpose of the 'Brokerage Relationship Disclosure Act'?",
        "answer": "To ensure that real estate licensees clearly disclose their relationship with customers and clients.",
        "category": "Disclosures",
        "difficulty": "hard",
        "explanation": "This act eliminated the previous presumption of single agency and established the transaction broker relationship as the default."
    },
    {
        "id": 280,
        "question": "What must be done to change from a 'no brokerage relationship' to a single agent?",
        "answer": "A written single agent agreement must be signed by the principal.",
        "category": "Brokerage Relationships",
        "difficulty": "medium",
        "explanation": "This change requires a formal, written agreement to establish the fiduciary duties."
    },
    {
        "id": 281,
        "question": "What is a 'principal' in an agency relationship?",
        "answer": "The person who grants authority to an agent to act on their behalf.",
        "category": "Agency",
        "difficulty": "easy",
        "explanation": "The buyer or seller is the principal in a single agency relationship."
    },
    {
        "id": 282,
        "question": "What is a 'customer' in a brokerage relationship?",
        "answer": "A person who the broker has no brokerage relationship with and is not represented in the transaction.",
        "category": "Brokerage Relationships",
        "difficulty": "easy",
        "explanation": "A customer is owed honesty and fair dealing, but not fiduciary duties."
    },
    {
        "id": 283,
        "question": "What is a 'client' in a brokerage relationship?",
        "answer": "A person who is represented by a single agent.",
        "category": "Brokerage Relationships",
        "difficulty": "easy",
        "explanation": "Only a single agent relationship creates a 'client' relationship with the principal."
    },
    {
        "id": 284,
        "question": "What is a 'termination of a single agency relationship'?",
        "answer": "The legal termination of the relationship between a broker and a client, ending the fiduciary duties.",
        "category": "Termination of Agency",
        "difficulty": "medium",
        "explanation": "Reasons for termination include mutual agreement, performance of the contract, or expiration of the agreement."
    },
    {
        "id": 285,
        "question": "When does an agency relationship terminate?",
        "answer": "When the purpose of the agency is fulfilled, the agreement expires, or by mutual consent.",
        "category": "Termination of Agency",
        "difficulty": "easy",
        "explanation": "The relationship ends once the objective, such as the sale of a property, is complete."
    },
    {
        "id": 286,
        "question": "What is a 'presenting' or 'showing agent'?",
        "answer": "A sales associate who shows a property to a prospective buyer and acts as a transaction broker for the buyer.",
        "category": "Brokerage Activities",
        "difficulty": "medium",
        "explanation": "This is a common role for a sales associate in a transaction broker relationship."
    },
    {
        "id": 287,
        "question": "What is 'substantive communication'?",
        "answer": "Any communication that goes beyond a general conversation and involves a discussion of the buyer's needs or wants.",
        "category": "Disclosures",
        "difficulty": "hard",
        "explanation": "A licensee must provide the 'no brokerage relationship' disclosure before substantive communication occurs with a customer."
    },
    {
        "id": 288,
        "question": "What is an 'in-house transaction'?",
        "answer": "A transaction where the buyer and the seller are both represented by sales associates from the same brokerage firm.",
        "category": "Brokerage Activities",
        "difficulty": "medium",
        "explanation": "In Florida, this is handled as a transaction brokerage relationship."
    },
    {
        "id": 289,
        "question": "What is a broker's duty when working as a transaction broker with a buyer?",
        "answer": "To assist the buyer with the transaction without advocating for them over the seller.",
        "category": "Transaction Broker",
        "difficulty": "medium",
        "explanation": "The broker has a duty to deal honestly and fairly with both parties."
    },
    {
        "id": 290,
        "question": "What must a sales associate do to terminate their single agent relationship with a client?",
        "answer": "The sales associate cannot terminate the relationship on their own; it must be done with the broker's approval.",
        "category": "Termination of Agency",
        "difficulty": "hard",
        "explanation": "The broker-client relationship is what is legally binding, not the associate-client relationship."
    },
    {
        "id": 291,
        "question": "What is 'informed consent'?",
        "answer": "A term for a principal's agreement to a course of action after being fully informed of all the relevant facts and potential risks.",
        "category": "Disclosures",
        "difficulty": "easy",
        "explanation": "A single agency agreement requires the informed consent of the client."
    },
    {
        "id": 292,
        "question": "What is 'imputed knowledge'?",
        "answer": "The legal concept that a broker is responsible for the knowledge of their sales associates.",
        "category": "Brokerage Duties",
        "difficulty": "hard",
        "explanation": "If a sales associate has knowledge of a material defect, the broker is also considered to have that knowledge."
    },
    {
        "id": 293,
        "question": "What is the purpose of a single agency agreement?",
        "answer": "To create a fiduciary relationship between a broker and a client and outline the terms of the representation.",
        "category": "Single Agency",
        "difficulty": "easy",
        "explanation": "This is the document that makes the relationship legally binding."
    },
    {
        "id": 294,
        "question": "What is the key difference between a single agent and a transaction broker with respect to the duty of confidentiality?",
        "answer": "A single agent has a duty of full confidentiality, while a transaction broker has a duty of limited confidentiality.",
        "category": "Brokerage Relationships",
        "difficulty": "medium",
        "explanation": "This is a primary distinction between the two relationships in Florida."
    },
    {
        "id": 295,
        "question": "What is 'title' in real estate?",
        "answer": "A legal concept that refers to ownership of real property and the evidence of that ownership, such as a deed.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "Title is not a physical document but a bundle of rights held by the owner."
    },
    {
        "id": 296,
        "question": "What is a 'deed'?",
        "answer": "A legal document that transfers title to real property from one party (the grantor) to another (the grantee).",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "A deed is the primary evidence of a title transfer."
    },
    {
        "id": 297,
        "question": "What are the essential elements of a valid deed in Florida?",
        "answer": "Must be in writing, signed by the grantor, have two witnesses, and contain a legal description of the property.",
        "category": "Title and Deeds",
        "difficulty": "hard",
        "explanation": "Unlike other states, Florida requires two witnesses for a deed to be valid."
    },
    {
        "id": 298,
        "question": "What is a 'general warranty deed'?",
        "answer": "The most common and comprehensive type of deed, offering the greatest protection to the grantee.",
        "category": "Deed Types",
        "difficulty": "medium",
        "explanation": "It contains covenants that protect the grantee against defects in the title, even if they were caused by a previous owner."
    },
    {
        "id": 299,
        "question": "What is a 'special warranty deed'?",
        "answer": "A deed in which the grantor warrants the title only against defects that arose during their period of ownership.",
        "category": "Deed Types",
        "difficulty": "medium",
        "explanation": "It offers less protection than a general warranty deed."
    },
    {
        "id": 300,
        "question": "What is a 'quitclaim deed'?",
        "answer": "A deed that transfers any interest the grantor has in the property, without making any promises or warranties about the title.",
        "category": "Deed Types",
        "difficulty": "easy",
        "explanation": "This type of deed is often used to clear a title or to transfer property between family members."
    },
    {
        "id": 301,
        "question": "What is a 'bargain and sale deed'?",
        "answer": "A deed that implies the grantor holds title but makes no warranties against encumbrances.",
        "category": "Deed Types",
        "difficulty": "medium",
        "explanation": "This deed is commonly used in foreclosures and tax sales."
    },
    {
        "id": 302,
        "question": "What is the 'grantor' in a deed?",
        "answer": "The person who is giving or conveying the title to the property.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "The grantor must be of legal age and mentally competent."
    },
    {
        "id": 303,
        "question": "What is the 'grantee' in a deed?",
        "answer": "The person who is receiving the title to the property.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "The grantee does not need to sign the deed."
    },
    {
        "id": 304,
        "question": "What is a 'chain of title'?",
        "answer": "The history of ownership for a property, showing the sequence of conveyances from one owner to the next.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "A break in the chain of title can create a cloud on the title."
    },
    {
        "id": 305,
        "question": "What is 'constructive notice'?",
        "answer": "The legal concept that recording a document in the public records gives everyone notice of its existence.",
        "category": "Title and Deeds",
        "difficulty": "medium",
        "explanation": "Recording a deed provides constructive notice to the world that the title has been transferred."
    },
    {
        "id": 306,
        "question": "What is 'actual notice'?",
        "answer": "The direct knowledge that a person has regarding a property's title.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "For example, physically possessing a property provides actual notice of a person's interest."
    },
    {
        "id": 307,
        "question": "What is 'title insurance'?",
        "answer": "An insurance policy that protects a property owner and/or lender against a loss from defects in the title.",
        "category": "Title and Deeds",
        "difficulty": "medium",
        "explanation": "Title insurance is a one-time fee paid at closing."
    },
    {
        "id": 308,
        "question": "What is a 'lien'?",
        "answer": "A legal claim or charge against a property as security for a debt.",
        "category": "Ownership Restrictions",
        "difficulty": "easy",
        "explanation": "A mortgage is a voluntary lien; a property tax lien is an involuntary lien."
    },
    {
        "id": 309,
        "question": "What is a 'specific lien'?",
        "answer": "A lien that is attached to a specific property and affects only that property.",
        "category": "Liens",
        "difficulty": "medium",
        "explanation": "Mortgage liens, mechanic's liens, and property tax liens are all specific liens."
    },
    {
        "id": 310,
        "question": "What is a 'general lien'?",
        "answer": "A lien that is attached to all of a person's property, both real and personal.",
        "category": "Liens",
        "difficulty": "medium",
        "explanation": "Examples include a judgment lien or an income tax lien."
    },
    {
        "id": 311,
        "question": "What is a 'mechanic's lien'?",
        "answer": "A specific lien placed on a property by a contractor or a supplier who has not been paid for their work or materials.",
        "category": "Liens",
        "difficulty": "medium",
        "explanation": "These liens are meant to protect those who improve real property."
    },
    {
        "id": 312,
        "question": "What is a 'lis pendens'?",
        "answer": "A notice recorded in the public records that a lawsuit is pending against a property.",
        "category": "Ownership Restrictions",
        "difficulty": "hard",
        "explanation": "The notice provides constructive notice to potential buyers that the property is involved in a legal dispute."
    },
    {
        "id": 313,
        "question": "What is 'title theory'?",
        "answer": "A legal concept where the lender holds legal title to the property until the loan is paid in full.",
        "category": "Title and Deeds",
        "difficulty": "medium",
        "explanation": "Florida is a 'lien theory' state, where the borrower holds the title."
    },
    {
        "id": 314,
        "question": "What is 'lien theory'?",
        "answer": "A legal concept where the borrower holds legal title to the property, and the lender holds a lien against it.",
        "category": "Title and Deeds",
        "difficulty": "medium",
        "explanation": "Florida is a lien theory state, which is why a mortgage is a lien."
    },
    {
        "id": 315,
        "question": "What is a 'cloud on the title'?",
        "answer": "Any claim or encumbrance that may impair or affect the owner's title to the property.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "A title search is conducted to find any clouds on the title."
    },
    {
        "id": 316,
        "question": "What is a 'title search'?",
        "answer": "The process of examining public records to determine the ownership and encumbrances on a property's title.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "A title search is a necessary step before issuing a title insurance policy."
    },
    {
        "id": 317,
        "question": "What is 'subrogation' in title insurance?",
        "answer": "The right of the title insurance company to sue the party responsible for a title defect after paying a claim.",
        "category": "Title and Deeds",
        "difficulty": "hard",
        "explanation": "This allows the insurance company to recover its losses from the party who caused the title issue."
    },
    {
        "id": 318,
        "question": "What is a 'covenant of seisin'?",
        "answer": "A promise in a general warranty deed that the grantor owns the property and has the right to convey title.",
        "category": "Deed Covenants",
        "difficulty": "hard",
        "explanation": "This is one of the five covenants in a general warranty deed."
    },
    {
        "id": 319,
        "question": "What is the 'covenant against encumbrances'?",
        "answer": "A promise in a general warranty deed that the property is free from all encumbrances except those specifically mentioned.",
        "category": "Deed Covenants",
        "difficulty": "hard",
        "explanation": "The grantor promises that there are no hidden liens or easements."
    },
    {
        "id": 320,
        "question": "What is the 'covenant of quiet enjoyment'?",
        "answer": "A promise in a general warranty deed that the grantee's title will be defended against any third-party claims.",
        "category": "Deed Covenants",
        "difficulty": "medium",
        "explanation": "This gives the grantee assurance that they will not be disturbed by legal challenges to their ownership."
    },
    {
        "id": 321,
        "question": "What is the 'covenant of further assurance'?",
        "answer": "A promise in a general warranty deed that the grantor will perform any acts necessary to perfect the grantee's title.",
        "category": "Deed Covenants",
        "difficulty": "hard",
        "explanation": "This is a promise to fix any future title issues that may arise."
    },
    {
        "id": 322,
        "question": "What is the 'covenant of warranty forever'?",
        "answer": "A promise in a general warranty deed that the grantor will compensate the grantee for any loss suffered from a future title defect.",
        "category": "Deed Covenants",
        "difficulty": "hard",
        "explanation": "This is the most comprehensive of the five covenants."
    },
    {
        "id": 323,
        "question": "What is a 'restriction' on a property?",
        "answer": "A limitation on the use of a property, which can be public (zoning) or private (deed restriction).",
        "category": "Ownership Restrictions",
        "difficulty": "easy",
        "explanation": "Restrictions limit what a property owner can do with their land."
    },
    {
        "id": 324,
        "question": "What is the difference between a lien and an easement?",
        "answer": "A lien is a monetary claim against a property, while an easement is a right to use a portion of a property for a specific purpose.",
        "category": "Encumbrances",
        "difficulty": "medium",
        "explanation": "Both are encumbrances on a property, but one is a financial claim and the other is a use right."
    },
    {
        "id": 325,
        "question": "What is an 'encumbrance'?",
        "answer": "A claim, charge, or liability that affects or limits the title to a property.",
        "category": "Encumbrances",
        "difficulty": "easy",
        "explanation": "An encumbrance does not necessarily prevent a property from being transferred."
    },
    {
        "id": 326,
        "question": "What is a 'private restriction'?",
        "answer": "A limitation on property use created by a developer or previous owner, such as a deed restriction.",
        "category": "Ownership Restrictions",
        "difficulty": "medium",
        "explanation": "These restrictions are usually put in place to maintain the value and character of a neighborhood."
    },
    {
        "id": 327,
        "question": "What is a 'plat map'?",
        "answer": "A map of a subdivision showing the boundaries of individual lots.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "Plat maps are recorded in the public records and are used for legal descriptions."
    },
    {
        "id": 328,
        "question": "What is a 'cloud on the title'?",
        "answer": "A defect or a flaw in the title that makes it difficult to transfer ownership.",
        "category": "Title and Deeds",
        "difficulty": "easy",
        "explanation": "A cloud on the title can be caused by a missing deed or a legal error."
    },
    {
        "id": 329,
        "question": "What is 'color of title'?",
        "answer": "A claim to title that appears to be valid but is not legally sound, often due to a defect in the deed.",
        "category": "Title and Deeds",
        "difficulty": "hard",
        "explanation": "This can be a basis for a claim of adverse possession."
    },
    {
        "id": 330,
        "question": "What is 'subrogation'?",
        "answer": "The right of an insurer to recover a loss from a third party after paying a claim.",
        "category": "Title and Deeds",
        "difficulty": "hard",
        "explanation": "Title insurance companies use this right to recover money they paid out for a title defect."
    },
    {
        "id": 331,
        "question": "What is a 'trustee's deed'?",
        "answer": "A deed used to convey property from a trustee to a buyer in a foreclosure sale.",
        "category": "Deed Types",
        "difficulty": "hard",
        "explanation": "This deed offers limited warranties and is often used in title theory states."
    },
    {
        "id": 332,
        "question": "What is the primary purpose of Florida real estate license law?",
        "answer": "To protect the public from unethical or incompetent real estate professionals.",
        "category": "License Law",
        "difficulty": "easy",
        "explanation": "The law establishes standards for licensure, education, and professional conduct."
    },
    {
        "id": 333,
        "question": "Who is exempt from holding a real estate license in Florida?",
        "answer": "Salaried employees of a property owner, those selling their own property, and court-appointed individuals such as guardians or trustees.",
        "category": "Licensing Exemptions",
        "difficulty": "medium",
        "explanation": "These individuals do not receive a commission for their services, which is a key criterion for licensure."
    },
    {
        "id": 334,
        "question": "What are the requirements to obtain a Florida sales associate license?",
        "answer": "Be at least 18 years old, have a high school diploma or equivalent, complete a 63-hour pre-license course, and pass the state exam.",
        "category": "Licensure Requirements",
        "difficulty": "easy",
        "explanation": "You must also submit a license application and be of good character."
    },
    {
        "id": 335,
        "question": "What is the purpose of the Department of Business and Professional Regulation (DBPR)?",
        "answer": "To license and regulate professionals and businesses in Florida, including real estate licensees.",
        "category": "Regulatory Bodies",
        "difficulty": "easy",
        "explanation": "The DBPR is the state agency that oversees the Florida Real Estate Commission (FREC)."
    },
    {
        "id": 336,
        "question": "What is the purpose of the Florida Real Estate Commission (FREC)?",
        "answer": "To enforce real estate license law and discipline licensees who violate the law.",
        "category": "Regulatory Bodies",
        "difficulty": "easy",
        "explanation": "FREC is a regulatory body under the DBPR that acts as a quasi-judicial body."
    },
    {
        "id": 337,
        "question": "What is the difference between a sales associate and a broker?",
        "answer": "A sales associate must work under the supervision of a licensed broker, while a broker can work independently and supervise others.",
        "category": "Licensing",
        "difficulty": "easy",
        "explanation": "A sales associate is an agent of their broker."
    },
    {
        "id": 338,
        "question": "What are the requirements to obtain a Florida broker's license?",
        "answer": "Have at least 24 months of experience as an active sales associate in the last five years, complete a 72-hour pre-license course, and pass the state exam.",
        "category": "Licensure Requirements",
        "difficulty": "medium",
        "explanation": "The experience requirement can also be fulfilled by having a related college degree."
    },
    {
        "id": 339,
        "question": "What is a 'broker-associate'?",
        "answer": "A licensed broker who chooses to work under the supervision of another broker.",
        "category": "Licensing",
        "difficulty": "easy",
        "explanation": "This allows a broker to practice without the liability of running their own brokerage."
    },
    {
        "id": 340,
        "question": "What is the time limit for completing a pre-license course and passing the state exam?",
        "answer": "There is no time limit for passing the state exam after completing the pre-license course, but the license application is only valid for two years.",
        "category": "Licensure Requirements",
        "difficulty": "medium",
        "explanation": "The course completion certificate does not expire, but the exam application does."
    },
    {
        "id": 341,
        "question": "What happens if a license application is denied?",
        "answer": "The applicant must be notified in writing and has the right to request a hearing to appeal the denial.",
        "category": "Licensing",
        "difficulty": "medium",
        "explanation": "Denials can occur due to criminal history, failing to disclose information, or other violations."
    },
    {
        "id": 342,
        "question": "What is a real estate license 'registration'?",
        "answer": "The process of a real estate broker's office being registered with the DBPR and FREC.",
        "category": "License Law",
        "difficulty": "easy",
        "explanation": "A brokerage, not just an individual, must be licensed and registered to conduct business."
    },
    {
        "id": 343,
        "question": "What is a 'license period' in Florida?",
        "answer": "The two-year period between the date a license is issued and its expiration date.",
        "category": "License Renewal",
        "difficulty": "easy",
        "explanation": "Licenses are renewed on a two-year cycle, with the exception of the first renewal period."
    },
    {
        "id": 344,
        "question": "What is the post-licensing education requirement for a sales associate?",
        "answer": "A 45-hour post-licensing course before the first license renewal.",
        "category": "Continuing Education",
        "difficulty": "medium",
        "explanation": "Failure to complete this course will result in the license becoming null and void."
    },
    {
        "id": 345,
        "question": "What is the continuing education requirement for a sales associate?",
        "answer": "14 hours of continuing education every two-year renewal period after the first renewal.",
        "category": "Continuing Education",
        "difficulty": "easy",
        "explanation": "This ensures that licensees stay current with legal and industry changes."
    },
    {
        "id": 346,
        "question": "What is the penalty for failing to complete the required continuing education?",
        "answer": "The license will expire and become involuntarily inactive.",
        "category": "License Status",
        "difficulty": "medium",
        "explanation": "A licensee can reactivate their license by completing the education and paying a fee."
    },
    {
        "id": 347,
        "question": "What is an 'involuntarily inactive' license?",
        "answer": "A license that has expired due to a licensee's failure to renew it or complete continuing education.",
        "category": "License Status",
        "difficulty": "medium",
        "explanation": "This status can be maintained for up to two years before the license becomes null and void."
    },
    {
        "id": 348,
        "question": "What is a 'voluntarily inactive' license?",
        "answer": "A license that a licensee chooses to place in an inactive status, without a desire to practice real estate at the moment.",
        "category": "License Status",
        "difficulty": "easy",
        "explanation": "The licensee can activate their license at any time by completing the required continuing education."
    },
    {
        "id": 349,
        "question": "What is a 'null and void' license?",
        "answer": "An expired license that cannot be reactivated and requires the person to re-apply and re-qualify for a license.",
        "category": "License Status",
        "difficulty": "hard",
        "explanation": "A license becomes null and void if it has been involuntarily inactive for more than two years."
    },
    {
        "id": 350,
        "question": "What is 'mutual recognition' in licensing?",
        "answer": "An agreement between Florida and another state that allows a licensee to obtain a Florida license without completing the full education and exam requirements.",
        "category": "Licensing",
        "difficulty": "hard",
        "explanation": "The applicant must still pass a 40-question Florida-specific real estate exam."
    },
    {
        "id": 351,
        "question": "How do you become a licensed real estate instructor?",
        "answer": "You must be a licensed real estate professional, have a college degree, and pass an instructor's exam.",
        "category": "Licensing",
        "difficulty": "medium",
        "explanation": "Instructors are licensed and regulated by the FREC."
    },
    {
        "id": 352,
        "question": "What is a 'reciprocal agreement' in licensing?",
        "answer": "An agreement where one state honors a professional license from another state without any additional requirements.",
        "category": "Licensing",
        "difficulty": "easy",
        "explanation": "Florida does not have reciprocal agreements for real estate licenses."
    },
    {
        "id": 353,
        "question": "What is the role of the Division of Real Estate (DRE)?",
        "answer": "A division within the DBPR that provides administrative support to the FREC.",
        "category": "Regulatory Bodies",
        "difficulty": "medium",
        "explanation": "The DRE handles the day-to-day operations of license processing and enforcement."
    },
    {
        "id": 354,
        "question": "What is the penalty for unlicensed real estate activity?",
        "answer": "It is a third-degree felony in Florida.",
        "category": "Violations and Penalties",
        "difficulty": "hard",
        "explanation": "The penalty for this includes a fine of up to $5,000 and up to five years in prison."
    },
    {
        "id": 355,
        "question": "What is 'continuing education'?",
        "answer": "The mandatory courses required for a licensee to renew their license after the first renewal period.",
        "category": "Continuing Education",
        "difficulty": "easy",
        "explanation": "The courses cover topics such as license law, ethics, and a specialty topic."
    },
    {
        "id": 356,
        "question": "What is the purpose of the 'post-licensing' education requirement?",
        "answer": "To provide new licensees with additional training and knowledge to practice real estate effectively and legally.",
        "category": "Continuing Education",
        "difficulty": "medium",
        "explanation": "This course must be completed before the first license renewal."
    },
    {
        "id": 357,
        "question": "How can a license be revoked?",
        "answer": "By a final order from the FREC for a violation of real estate license law.",
        "category": "Violations and Penalties",
        "difficulty": "easy",
        "explanation": "License revocation is the most severe penalty and cannot be appealed."
    },
    {
        "id": 358,
        "question": "What is a 'cease and desist' order?",
        "answer": "A court order issued by the DBPR to stop an unlicensed person from conducting real estate activities.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "The DBPR can issue this order without a formal hearing."
    },
    {
        "id": 359,
        "question": "What is a 'prima facie' evidence of licensure?",
        "answer": "The real estate license itself, which is legal proof that a person is licensed.",
        "category": "License Law",
        "difficulty": "medium",
        "explanation": "This means the license is considered valid on its face."
    },
    {
        "id": 360,
        "question": "What is the purpose of the 'Real Estate Recovery Fund'?",
        "answer": "To provide compensation to individuals who have suffered financial losses due to the actions of a licensed real estate professional.",
        "category": "Violations and Penalties",
        "difficulty": "easy",
        "explanation": "The fund is a last resort for consumers who have been harmed."
    },
    {
        "id": 361,
        "question": "What are the rules regarding a change of address for a licensee?",
        "answer": "The licensee must notify the DBPR of the change within 10 days.",
        "category": "License Law",
        "difficulty": "easy",
        "explanation": "Failure to do so can result in disciplinary action."
    },
    {
        "id": 362,
        "question": "Who appoints the members of the Florida Real Estate Commission?",
        "answer": "The Governor of Florida.",
        "category": "Regulatory Bodies",
        "difficulty": "medium",
        "explanation": "The commission is made up of seven members, four of whom must be licensed brokers."
    },
    {
        "id": 363,
        "question": "What is the purpose of a real estate closing?",
        "answer": "To finalize the transfer of property ownership from the seller to the buyer and settle all financial obligations.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "The closing is the point at which the deed is delivered and the buyer takes legal possession of the property."
    },
    {
        "id": 364,
        "question": "What is a 'proration' at closing?",
        "answer": "The division of certain expenses, such as property taxes or homeowners' association fees, between the buyer and the seller.",
        "category": "Closing Computations",
        "difficulty": "easy",
        "explanation": "Prorations ensure that each party only pays for the period of time they owned the property. For example, if annual property taxes are $3,600 and the seller owned the property for 90 days, the seller would be responsible for their portion (90/365 of the total), and the buyer would be credited for the remaining days. Common items prorated include property taxes, homeowners' association fees, and prepaid insurance."
    },
    {
        "id": 365,
        "question": "What is the formula for calculating prorated property taxes?",
        "answer": "(Annual Property Taxes / 365 days) x number of days owned by each party.",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "Step 1: Divide the annual property tax by 365 to get the daily rate. Step 2: Multiply the daily rate by the number of days each party owned the property. The seller is debited (owes) for the days they owned the property, and the buyer is credited (receives) for those same days since they'll be responsible going forward. Note: Some calculations use a 360-day year, but 365 is standard in Florida. Always count the closing day as belonging to the buyer."
    },
    {
        "id": 366,
        "question": "What is 'credit' on a closing statement?",
        "answer": "A financial amount that a party receives, such as a loan amount or a prorated amount of prepaid expenses.",
        "category": "Closing Computations",
        "difficulty": "easy",
        "explanation": "A credit is money owed TO a party at closing - it increases what they receive or reduces what they owe. For buyers, common credits include: loan proceeds, earnest money deposit (already paid), prorated property taxes (seller's share), and seller concessions. For sellers, common credits include: sale price, prorated property taxes (buyer's share), and prepaid expenses refunded by the buyer."
    },
    {
        "id": 367,
        "question": "What is 'debit' on a closing statement?",
        "answer": "A financial amount that a party owes, such as the purchase price or a prorated expense.",
        "category": "Closing Computations",
        "difficulty": "easy",
        "explanation": "A debit is money that a party must PAY at closing - it increases what they owe or reduces what they receive. For buyers, common debits include: purchase price, loan origination fees, title insurance, prorated property taxes (buyer's share), and closing costs. For sellers, common debits include: broker's commission, prorated property taxes (seller's share), documentary stamp taxes, and any existing mortgage payoff."
    },
    {
        "id": 368,
        "question": "What is the Florida Documentary Stamp Tax on Deeds?",
        "answer": "$0.70 per $100 of the property's purchase price.",
        "category": "Transfer Taxes",
        "difficulty": "medium",
        "explanation": "This is a Florida state-mandated transfer tax set by Florida Statutes. The rate is $0.70 for every $100 of the purchase price (or $0.007 per dollar). To calculate: divide the purchase price by $100, then multiply by $0.70. Example: $300,000 purchase = ($300,000 ÷ $100) × $0.70 = $2,100. This tax is typically paid by the seller, but payment responsibility can be negotiated in the contract. It's collected at closing and must be paid for the deed to be recorded."
    },
    {
        "id": 369,
        "question": "What is the Florida Documentary Stamp Tax on Notes?",
        "answer": "$0.35 per $100 of the new mortgage loan amount.",
        "category": "Transfer Taxes",
        "difficulty": "medium",
        "explanation": "This is a Florida state-mandated tax on new mortgages, set by Florida Statutes. The rate is $0.35 for every $100 of the new mortgage loan amount (or $0.0035 per dollar). To calculate: divide the loan amount by $100, then multiply by $0.35. Example: $240,000 loan = ($240,000 ÷ $100) × $0.35 = $840. This tax is typically paid by the buyer (the borrower) and is based on the amount of the new mortgage loan, not the purchase price. It's collected at closing when the mortgage note is recorded."
    },
    {
        "id": 370,
        "question": "What is the Florida Intangible Tax on Mortgages?",
        "answer": "$0.002 per $1 of the new mortgage loan amount, or 2 mills.",
        "category": "Transfer Taxes",
        "difficulty": "hard",
        "explanation": "This is a Florida state-mandated one-time tax on new mortgages, set by Florida Statutes. The rate is $0.002 per $1 of the loan amount, which equals 2 mills (a mill is $0.001, so 2 mills = $0.002). To calculate: multiply the loan amount by 0.002. Example: $240,000 loan = $240,000 × 0.002 = $480. This tax is typically paid by the buyer (borrower) at closing and is a one-time charge for the privilege of recording the mortgage in public records. It's separate from the Documentary Stamp Tax on Notes."
    },
    {
        "id": 371,
        "question": "A home sells for $300,000 with a new mortgage of $240,000. How much is the Documentary Stamp Tax on the deed?",
        "answer": "$2,100 ($300,000 / $100 * $0.70).",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "The Documentary Stamp Tax on Deeds is calculated on the PURCHASE PRICE, not the mortgage amount. Step 1: Divide $300,000 by $100 = 3,000. Step 2: Multiply 3,000 by $0.70 = $2,100. The mortgage amount ($240,000) is irrelevant for this calculation - only the purchase price matters. This tax is typically paid by the seller and is a Florida state-mandated transfer tax."
    },
    {
        "id": 372,
        "question": "A home sells for $300,000 with a new mortgage of $240,000. How much is the Documentary Stamp Tax on the note?",
        "answer": "$840 ($240,000 / $100 * $0.35).",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "The Documentary Stamp Tax on Notes is calculated on the NEW MORTGAGE LOAN AMOUNT, not the purchase price. Step 1: Divide $240,000 by $100 = 2,400. Step 2: Multiply 2,400 by $0.35 = $840. The purchase price ($300,000) is not used in this calculation - only the mortgage loan amount matters. This tax is typically paid by the buyer (borrower) and is a Florida state-mandated tax on new mortgages."
    },
    {
        "id": 373,
        "question": "A home sells for $300,000 with a new mortgage of $240,000. How much is the Intangible Tax?",
        "answer": "$480 ($240,000 * 0.002).",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "The Intangible Tax on Mortgages is calculated on the NEW MORTGAGE LOAN AMOUNT. The rate is 2 mills, which equals $0.002 per dollar. Step 1: Multiply $240,000 by 0.002 = $480. The purchase price ($300,000) is not used - only the mortgage amount matters. This is a Florida state-mandated one-time tax, typically paid by the buyer (borrower) at closing. It's separate from the Documentary Stamp Tax on Notes, even though both are based on the loan amount."
    },
    {
        "id": 374,
        "question": "What is a 'closing statement' (or Closing Disclosure)?",
        "answer": "A document that provides a detailed accounting of all funds in a real estate transaction.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "The Closing Disclosure replaced the HUD-1 statement and is provided to the buyer and seller at least three days before closing."
    },
    {
        "id": 375,
        "question": "What is a 'loan origination fee'?",
        "answer": "A fee charged by a lender to process a new loan application.",
        "category": "Closing Costs",
        "difficulty": "easy",
        "explanation": "The fee is typically a percentage of the loan amount."
    },
    {
        "id": 376,
        "question": "What is the formula for calculating interest on a mortgage?",
        "answer": "Principal x Rate x Time.",
        "category": "Mortgage Computations",
        "difficulty": "easy",
        "explanation": "This is the simple interest formula: Interest = Principal × Rate × Time. Principal is the loan balance, Rate is the annual interest rate as a decimal (e.g., 6% = 0.06), and Time is the period in years. For monthly interest: divide the annual rate by 12 and use 1/12 for time. For daily interest (used in prorations): divide the annual rate by 365 and use the number of days/365 for time. Example: $100,000 loan at 6% for 1 month = $100,000 × 0.06 × (1/12) = $500."
    },
    {
        "id": 377,
        "question": "What is the purpose of a 'broker's commission' on a closing statement?",
        "answer": "The fee paid to the listing and/or selling broker for their services in the transaction.",
        "category": "Closing Costs",
        "difficulty": "easy",
        "explanation": "The commission is typically paid by the seller and is based on a percentage of the sales price."
    },
    {
        "id": 378,
        "question": "What is a 'procuring cause'?",
        "answer": "The real estate broker who initiated the chain of events that led to the sale of a property.",
        "category": "Brokerage Activities",
        "difficulty": "medium",
        "explanation": "The procuring cause is the party who is entitled to a commission."
    },
    {
        "id": 379,
        "question": "What are 'title insurance premiums'?",
        "answer": "A one-time fee paid at closing to purchase a title insurance policy.",
        "category": "Closing Costs",
        "difficulty": "easy",
        "explanation": "The policy protects the buyer and/or the lender from title defects."
    },
    {
        "id": 380,
        "question": "A property with an assessed value of $250,000 has a millage rate of 15 mills. What are the annual property taxes?",
        "answer": "$3,750 ($250,000 * 0.015).",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "A mill is one-tenth of a cent, which equals $0.001 per dollar of assessed value. To convert mills to a decimal: divide by 1,000. So 15 mills = 15 ÷ 1,000 = 0.015. Step 1: Multiply assessed value by the millage rate as a decimal: $250,000 × 0.015 = $3,750. Alternatively: $250,000 × 15 mills × $0.001 = $3,750. The millage rate is set by local taxing authorities (county, city, school district) and is applied to the assessed value (not market value) to determine property taxes."
    },
    {
        "id": 381,
        "question": "What is the 'loan-to-value (LTV) ratio'?",
        "answer": "The ratio of the loan amount to the property's appraised value or sales price, whichever is lower.",
        "category": "Mortgage Computations",
        "difficulty": "easy",
        "explanation": "The LTV ratio shows what percentage of the property value is being financed. Lenders use the LOWER of the appraised value or sales price to calculate LTV, as this protects them from overvaluing the property. Formula: (Loan Amount ÷ Property Value) × 100 = LTV%. Example: $200,000 loan on a $250,000 home = 80% LTV. Lower LTV ratios mean less risk for lenders, so borrowers with lower LTV ratios typically get better interest rates. Most conventional loans require LTV of 80% or less to avoid private mortgage insurance (PMI)."
    },
    {
        "id": 382,
        "question": "What is the formula for calculating a loan-to-value ratio?",
        "answer": "(Loan Amount / Property Value) x 100.",
        "category": "Mortgage Computations",
        "difficulty": "easy",
        "explanation": "Step 1: Divide the loan amount by the property value (use the lower of appraised value or sales price). Step 2: Multiply by 100 to convert to a percentage. Example: $200,000 loan ÷ $250,000 property value = 0.80, then 0.80 × 100 = 80% LTV. This means the borrower is financing 80% of the property value and putting down 20% as a down payment. The property value used should be the lower of the appraised value or sales price to protect the lender."
    },
    {
        "id": 383,
        "question": "What is the purpose of a 'settlement statement'?",
        "answer": "A document that summarizes all the financial debits and credits for both the buyer and the seller at closing.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "The settlement statement is used to reconcile all the money in the transaction."
    },
    {
        "id": 384,
        "question": "What is the 'escrow' process in a closing?",
        "answer": "The process of a neutral third party holding funds and documents until all conditions of the contract are met.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "Escrow ensures that all parties fulfill their obligations before the transaction is finalized."
    },
    {
        "id": 385,
        "question": "What is the 'closing date'?",
        "answer": "The specific date on which the buyer and seller sign the final documents and the property is transferred.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "The closing date is determined in the purchase and sale agreement."
    },
    {
        "id": 386,
        "question": "What is the 'earnest money deposit' on a closing statement?",
        "answer": "A credit to the buyer and a debit to the broker, as the funds are being transferred from the broker's escrow account.",
        "category": "Closing Computations",
        "difficulty": "medium",
        "explanation": "Earnest money is the deposit the buyer paid when making the offer, which was held in the broker's escrow account. At closing, this money is credited to the buyer (reduces what they owe) because they already paid it. Simultaneously, it's debited from the broker (they must release it from escrow). This is a transfer of funds, not new money. Example: If the buyer paid $5,000 earnest money and the purchase price is $300,000, the buyer's total payment due at closing is $295,000 (the earnest money is credited toward the purchase price)."
    },
    {
        "id": 387,
        "question": "What is a 'title search fee' on a closing statement?",
        "answer": "A fee paid to a title company to search the public records for any title defects.",
        "category": "Closing Costs",
        "difficulty": "easy",
        "explanation": "This is a standard closing cost for the buyer."
    },
    {
        "id": 388,
        "question": "How is a loan balance calculated for a prorated interest payment?",
        "answer": "The loan balance is multiplied by the interest rate and divided by 365, then multiplied by the number of days owed.",
        "category": "Closing Computations",
        "difficulty": "hard",
        "explanation": "This formula calculates daily interest on an existing loan that's being assumed or not paid off at closing. Step 1: Multiply the loan balance by the annual interest rate (as a decimal) to get annual interest. Step 2: Divide by 365 to get daily interest rate. Step 3: Multiply by the number of days owed. Formula: (Loan Balance × Interest Rate ÷ 365) × Days Owed. Example: $200,000 loan at 6% for 15 days = ($200,000 × 0.06 ÷ 365) × 15 = ($12,000 ÷ 365) × 15 = $32.88 × 15 = $493.15. This is used when a buyer assumes an existing mortgage or when calculating interest for partial months."
    },
    {
        "id": 389,
        "question": "A buyer is getting a $250,000 mortgage with a loan origination fee of 1.5 points. What is the fee in dollars?",
        "answer": "$3,750 ($250,000 * 0.015).",
        "category": "Mortgage Computations",
        "difficulty": "medium",
        "explanation": "One point equals 1% of the loan amount. To calculate: convert points to a decimal (1.5 points = 0.015), then multiply by the loan amount. Step 1: 1.5 points = 1.5% = 0.015 as a decimal. Step 2: $250,000 × 0.015 = $3,750. Points are fees paid to the lender, typically at closing, and can be used to 'buy down' the interest rate (discount points) or as an origination fee. One point on a $250,000 loan = $2,500, so 1.5 points = $3,750."
    },
    {
        "id": 390,
        "question": "How is a broker's commission calculated?",
        "answer": "The sales price multiplied by the commission rate.",
        "category": "Closing Computations",
        "difficulty": "easy",
        "explanation": "Total commission = Sales Price × Commission Rate (as a decimal). Step 1: Convert the commission rate percentage to a decimal (e.g., 6% = 0.06). Step 2: Multiply the sales price by the decimal rate. Example: $300,000 sale at 6% commission = $300,000 × 0.06 = $18,000 total commission. If the commission is split between listing and selling brokers (e.g., 50/50), each would receive $9,000. The commission rate is always negotiable and is typically paid by the seller at closing."
    },
    {
        "id": 391,
        "question": "A seller owes $1,500 in annual property taxes. The closing is on March 31. What is the seller's proration?",
        "answer": "$375.00 ($1,500 / 365 days * 90 days).",
        "category": "Closing Computations",
        "difficulty": "hard",
        "explanation": "Step 1: Calculate daily rate: $1,500 ÷ 365 = $4.11 per day. Step 2: Count seller's days: January (31) + February (28) + March (31) = 90 days. Note: March 31 is the closing date, which typically belongs to the buyer, but in this calculation, we're counting through March 31 for the seller. Step 3: Multiply daily rate by days: $4.11 × 90 = $369.90, or using exact calculation: ($1,500 ÷ 365) × 90 = $375.00. The seller is debited (owes) $375.00, and the buyer is credited (receives) $375.00 since they'll be responsible for the remaining 275 days of the year. This uses a 365-day year; some calculations use 360 days."
    },
    {
        "id": 392,
        "question": "What is the primary role of a real estate agent at closing?",
        "answer": "To ensure that all parties have fulfilled their obligations and that the transaction proceeds smoothly.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "The agent's job is to represent their client's interests and communicate with all parties."
    },
    {
        "id": 393,
        "question": "What is 'RESPA' in the context of closing?",
        "answer": "The Real Estate Settlement Procedures Act, a federal law that requires lenders to provide borrowers with information about closing costs and settlement procedures.",
        "category": "Closing Process",
        "difficulty": "easy",
        "explanation": "RESPA is designed to prevent kickbacks and ensure transparency in the real estate closing process."
    },
    {
        "id": 394,
        "question": "What is a 'legal description' of real property?",
        "answer": "A precise and legally accepted method of locating and identifying a property, which is used in deeds and mortgages.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "A legal description is required for a document to be recorded and is more accurate than a street address."
    },
    {
        "id": 395,
        "question": "What is the 'metes and bounds' method of legal description?",
        "answer": "A method that describes a property's boundaries by starting at a specific point (the point of beginning) and following a series of courses and distances.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "'Metes' refers to the distance and direction, while 'bounds' refers to the natural and man-made boundaries."
    },
    {
        "id": 396,
        "question": "What is a 'point of beginning' (POB)?",
        "answer": "The starting point of a metes and bounds legal description.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "The description must always return to the POB to be a valid closed loop."
    },
    {
        "id": 397,
        "question": "What is the 'lot and block' method of legal description?",
        "answer": "A method that describes a property by referencing a specific lot number within a recorded plat map.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "This is the most common method for describing properties in subdivisions."
    },
    {
        "id": 398,
        "question": "What is a 'plat map'?",
        "answer": "A detailed survey map of a subdivision that shows the boundaries of each lot, block, street, and easement.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "The plat map is recorded in the public records of the county."
    },
    {
        "id": 399,
        "question": "What is the 'Government Survey System' (or Rectangular Survey System)?",
        "answer": "A method of legal description that divides land into a grid system using principal meridians and base lines.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "This method is used in many states but is not the primary method in Florida, where metes and bounds and lot and block are more common."
    },
    {
        "id": 400,
        "question": "What is a 'principal meridian'?",
        "answer": "A north-south line used as a reference point in the Government Survey System.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "There is only one principal meridian in Florida, which runs through Tallahassee."
    },
    {
        "id": 401,
        "question": "What is a 'base line'?",
        "answer": "An east-west line used as a reference point in the Government Survey System.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "The base line intersects the principal meridian in Tallahassee."
    },
    {
        "id": 402,
        "question": "What is a 'township' in the Government Survey System?",
        "answer": "A six-mile by six-mile square of land, containing 36 square miles.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "Townships are created by the intersection of township lines and range lines."
    },
    {
        "id": 403,
        "question": "How many sections are in a township?",
        "answer": "36 sections.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "Each section is one square mile."
    },
    {
        "id": 404,
        "question": "How many acres are in one section?",
        "answer": "640 acres.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "A section is one square mile, and one square mile contains 640 acres."
    },
    {
        "id": 405,
        "question": "How are sections numbered within a township?",
        "answer": "From 1 to 36, starting in the northeast corner and moving west, then south, in a serpentine pattern.",
        "category": "Legal Descriptions",
        "difficulty": "hard",
        "explanation": "This numbering system ensures a logical and predictable method for locating sections within a township."
    },
    {
        "id": 406,
        "question": "What is a 'survey'?",
        "answer": "A professional measurement of a property's boundaries, performed by a licensed surveyor.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "A survey is used to create a legal description and to identify any encroachments."
    },
    {
        "id": 407,
        "question": "What is an 'assessor's parcel number' (APN)?",
        "answer": "A number assigned by a county tax assessor to a parcel of real estate for identification and record-keeping purposes.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "An APN is not a legal description and should not be used as such in a deed."
    },
    {
        "id": 408,
        "question": "What is the difference between a street address and a legal description?",
        "answer": "A street address is a general location for mailing purposes, while a legal description is a precise, legally binding identifier of a property's boundaries.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "A legal description is required for a deed; a street address is not."
    },
    {
        "id": 409,
        "question": "What is a 'benchmark'?",
        "answer": "A permanent marker with a known elevation, used by surveyors as a reference point for future measurements.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "Benchmarks are a key part of the Government Survey System."
    },
    {
        "id": 410,
        "question": "What is 'course and distance'?",
        "answer": "A direction and a length, used in a metes and bounds legal description.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "A course is a direction, such as 'North 45 degrees East', and a distance is a length, such as '100 feet'."
    },
    {
        "id": 411,
        "question": "What is a 'monument' in a metes and bounds description?",
        "answer": "A natural or man-made marker used to identify a boundary, such as a rock, a tree, or a fence post.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "Monuments are a key part of the metes and bounds method."
    },
    {
        "id": 412,
        "question": "What is the purpose of an 'encroachment' survey?",
        "answer": "To determine if a structure on a property extends over the property line of an adjacent parcel.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "An encroachment is a type of encumbrance that must be cleared before a sale."
    },
    {
        "id": 413,
        "question": "What is a 'quarter section' in the Government Survey System?",
        "answer": "A quarter of a section, which is 160 acres.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "A section is 640 acres, so a quarter section is 160 acres."
    },
    {
        "id": 414,
        "question": "What is a 'fractional section'?",
        "answer": "A section of land in the Government Survey System that is not a full 640 acres, often due to a river or a lake.",
        "category": "Legal Descriptions",
        "difficulty": "hard",
        "explanation": "Fractional sections are a common feature in states with irregular boundaries."
    },
    {
        "id": 415,
        "question": "How do you calculate the area of a lot using a legal description?",
        "answer": "You must use the metes and bounds description and a survey to calculate the area.",
        "category": "Legal Descriptions",
        "difficulty": "hard",
        "explanation": "This is a complex calculation that is typically performed by a licensed surveyor."
    },
    {
        "id": 416,
        "question": "What is the primary legal description method used in Florida?",
        "answer": "The lot and block method, followed by metes and bounds.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "The Government Survey System is used in Florida, but it is not the primary method for new subdivisions."
    },
    {
        "id": 417,
        "question": "What is a 'quarter-quarter section'?",
        "answer": "A quarter of a quarter of a section, which is 40 acres.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "This is a common unit of measurement in the Government Survey System."
    },
    {
        "id": 418,
        "question": "What is an 'easement'?",
        "answer": "The right to use the land of another for a specific purpose.",
        "category": "Legal Descriptions",
        "difficulty": "easy",
        "explanation": "Easements are often included in a legal description to show the location of a right-of-way."
    },
    {
        "id": 419,
        "question": "How is a condominium unit legally described?",
        "answer": "By its unit number, building number, and the name of the condominium, along with the legal description of the land.",
        "category": "Legal Descriptions",
        "difficulty": "medium",
        "explanation": "The legal description references the recorded condominium plat map."
    },
    {
        "id": 420,
        "question": "What is the purpose of the Florida Residential Landlord and Tenant Act?",
        "answer": "To protect both landlords and tenants by regulating lease agreements and evictions.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "This act outlines the rights and responsibilities of both parties in a rental agreement."
    },
    {
        "id": 421,
        "question": "What is the federal Fair Housing Act?",
        "answer": "A federal law that prohibits discrimination in the sale, rental, and financing of housing based on protected classes.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "The protected classes are race, color, religion, sex, national origin, familial status, and handicap."
    },
    {
        "id": 422,
        "question": "What is 'familial status' under the Fair Housing Act?",
        "answer": "A protected class that includes families with children under 18 or a pregnant person.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "This prohibits landlords from discriminating against families with children."
    },
    {
        "id": 423,
        "question": "What is 'handicap' under the Fair Housing Act?",
        "answer": "A protected class that includes individuals with a mental or physical disability.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "This prohibits discrimination against individuals with disabilities and requires reasonable accommodations."
    },
    {
        "id": 424,
        "question": "What is the 'Americans with Disabilities Act' (ADA)?",
        "answer": "A federal law that prohibits discrimination against individuals with disabilities in all areas of public life, including employment and public accommodations.",
        "category": "Federal Laws",
        "difficulty": "medium",
        "explanation": "The ADA requires commercial properties to be accessible to people with disabilities."
    },
    {
        "id": 425,
        "question": "What is the 'Real Estate Settlement Procedures Act' (RESPA)?",
        "answer": "A federal law that requires lenders to provide borrowers with a good-faith estimate of closing costs and prohibits kickbacks.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "RESPA ensures transparency in the real estate settlement process."
    },
    {
        "id": 426,
        "question": "What is the 'Truth in Lending Act' (TILA)?",
        "answer": "A federal law that requires lenders to disclose all loan costs, including the annual percentage rate (APR).",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "TILA's purpose is to promote the informed use of consumer credit."
    },
    {
        "id": 427,
        "question": "What is the 'Equal Credit Opportunity Act' (ECOA)?",
        "answer": "A federal law that prohibits discrimination in lending based on race, color, religion, national origin, sex, marital status, or age.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "ECOA ensures that all credit applicants are treated fairly."
    },
    {
        "id": 428,
        "question": "What is the 'Florida Deceptive and Unfair Trade Practices Act'?",
        "answer": "A state law that protects consumers from unfair, deceptive, and misleading business practices.",
        "category": "State Laws",
        "difficulty": "medium",
        "explanation": "This law applies to real estate licensees and can be enforced by the Florida Attorney General."
    },
    {
        "id": 429,
        "question": "What are the rules regarding a broker's advertising under Florida law?",
        "answer": "All advertising must be in the name of the brokerage and supervised by the broker.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "This prevents licensees from using 'blind ads' that do not identify the brokerage."
    },
    {
        "id": 430,
        "question": "What are the rules regarding a real estate licensee and a 'do not call' list?",
        "answer": "Licensees must not call a phone number on the national or state 'do not call' list, unless they have an existing business relationship with the person.",
        "category": "Federal Laws",
        "difficulty": "medium",
        "explanation": "The national 'do not call' list is enforced by the Federal Trade Commission (FTC)."
    },
    {
        "id": 431,
        "question": "What is the purpose of the 'Florida Condominium Act'?",
        "answer": "To regulate the creation, operation, and management of condominiums in Florida.",
        "category": "State Laws",
        "difficulty": "medium",
        "explanation": "This act protects the rights of condominium owners and establishes rules for the condominium association."
    },
    {
        "id": 432,
        "question": "What is the 'Lead-Based Paint Disclosure Rule'?",
        "answer": "A federal law that requires sellers and landlords of homes built before 1978 to disclose any known lead-based paint hazards.",
        "category": "Federal Laws",
        "difficulty": "easy",
        "explanation": "The purpose of this law is to protect the health of children and families."
    },
    {
        "id": 433,
        "question": "What is the purpose of the 'Florida Deceptive and Unfair Trade Practices Act'?",
        "answer": "To protect consumers from deceptive, unfair, and misleading business practices.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "This law applies to real estate licensees and can be enforced by the Florida Attorney General."
    },
    {
        "id": 434,
        "question": "What is 'commingling' of funds?",
        "answer": "The illegal act of mixing a client's funds with a broker's personal or business funds.",
        "category": "State Laws",
        "difficulty": "medium",
        "explanation": "This is a violation of Florida license law and can lead to disciplinary action."
    },
    {
        "id": 435,
        "question": "What is 'conversion' of funds?",
        "answer": "The illegal act of using a client's funds for a broker's personal or business expenses.",
        "category": "State Laws",
        "difficulty": "medium",
        "explanation": "Conversion is a more serious offense than commingling and is considered a form of theft."
    },
    {
        "id": 436,
        "question": "What is a 'kickback' under RESPA?",
        "answer": "An unearned fee or rebate paid to a broker for directing business to a specific service provider, which is illegal unless a service is rendered.",
        "category": "Federal Laws",
        "difficulty": "hard",
        "explanation": "RESPA prohibits kickbacks to prevent brokers from steering clients to a specific company for personal gain."
    },
    {
        "id": 437,
        "question": "What is the 'Florida Real Estate Recovery Fund'?",
        "answer": "A fund that provides compensation to individuals who have suffered financial losses due to the illegal actions of a real estate professional.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "The fund is a last resort for consumers who have been harmed."
    },
    {
        "id": 438,
        "question": "What is 'zoning'?",
        "answer": "A public restriction on a property's use, enforced by a local government.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "Zoning is an exercise of the government's police power."
    },
    {
        "id": 439,
        "question": "What is the purpose of the 'Florida Real Estate Recovery Fund'?",
        "answer": "To provide compensation to individuals who have suffered monetary damages as a result of a licensed real estate professional's illegal or unethical actions.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "The fund protects the public from losses caused by licensees."
    },
    {
        "id": 440,
        "question": "What is the 'Florida Deceptive and Unfair Trade Practices Act'?",
        "answer": "A state law that protects consumers from deceptive, unfair, and misleading business practices.",
        "category": "State Laws",
        "difficulty": "easy",
        "explanation": "This law applies to real estate licensees and can be enforced by the Florida Attorney General."
    },
    {
        "id": 441,
        "question": "What is the primary purpose of property taxes?",
        "answer": "To fund local government services such as schools, police, and fire departments.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "easy",
        "explanation": "Property taxes are the main source of revenue for local governments."
    },
    {
        "id": 442,
        "question": "What is a 'mill' in real estate taxation?",
        "answer": "A rate used to calculate property taxes, equal to one-tenth of a cent or $0.001.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "easy",
        "explanation": "The formula for calculating taxes is the assessed value multiplied by the millage rate."
    },
    {
        "id": 443,
        "question": "What is 'assessed value'?",
        "answer": "The value of a property as determined by a tax assessor for the purpose of levying property taxes.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "easy",
        "explanation": "Assessed value is often different from a property's market value."
    },
    {
        "id": 444,
        "question": "What is a 'homestead exemption' in Florida?",
        "answer": "A tax exemption of up to $50,000 for a person's primary residence.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "The homestead exemption is a key benefit for Florida homeowners."
    },
    {
        "id": 445,
        "question": "What is the 'Save Our Homes' amendment?",
        "answer": "An amendment that limits the increase in the assessed value of a Florida homestead property to 3% per year or the CPI, whichever is lower.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "hard",
        "explanation": "This amendment helps to keep property taxes from rising too quickly for homeowners."
    },
    {
        "id": 446,
        "question": "What is the difference between ad valorem taxes and special assessments?",
        "answer": "Ad valorem taxes are based on a property's assessed value, while special assessments are for specific improvements that benefit a property.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "An example of a special assessment is a new sidewalk or sewer line."
    },
    {
        "id": 447,
        "question": "What is a 'property tax lien'?",
        "answer": "A specific, involuntary lien placed on a property for unpaid property taxes.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "easy",
        "explanation": "Property tax liens have the highest priority over all other liens."
    },
    {
        "id": 448,
        "question": "What is a 'transfer tax'?",
        "answer": "A tax paid upon the transfer of real estate, which is typically calculated as a percentage of the sales price.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "easy",
        "explanation": "In Florida, this is known as the Documentary Stamp Tax on deeds."
    },
    {
        "id": 449,
        "question": "What is a 'capital gain' in real estate?",
        "answer": "The profit realized from the sale of an asset, which is subject to capital gains taxes.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "The capital gain is the difference between the sales price and the property's cost basis."
    },
    {
        "id": 450,
        "question": "What is the capital gains tax exemption for a primary residence?",
        "answer": "An exemption of up to $250,000 for a single person and $500,000 for a married couple, if they lived in the home for two of the last five years.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "hard",
        "explanation": "This is a significant tax benefit for homeowners."
    },
    {
        "id": 451,
        "question": "What is 'depreciation' for tax purposes?",
        "answer": "A tax deduction for the gradual wear and tear of an income-producing property.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "Depreciation allows a property owner to deduct a portion of the property's value each year."
    },
    {
        "id": 452,
        "question": "What is a '1031 exchange'?",
        "answer": "A tax-deferred exchange that allows an investor to sell an investment property and reinvest the proceeds into a like-kind property to defer capital gains taxes.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "hard",
        "explanation": "This is a major tax benefit for real estate investors."
    },
    {
        "id": 453,
        "question": "What is the 'adjusted basis' of a property?",
        "answer": "The original cost of a property plus the cost of any capital improvements, minus any depreciation.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "The adjusted basis is used to calculate the capital gain upon the sale of a property."
    },
    {
        "id": 454,
        "question": "What are the key elements of a 1031 exchange?",
        "answer": "The properties must be 'like-kind,' and the exchange must be completed within a specific timeframe.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "hard",
        "explanation": "The investor has 45 days to identify a new property and 180 days to close."
    },
    {
        "id": 455,
        "question": "How are real estate property taxes paid in Florida?",
        "answer": "In arrears, meaning they are due at the end of the year for the year just past.",
        "category": "Taxes Affecting Real Estate",
        "difficulty": "medium",
        "explanation": "Property taxes are a key proration at closing."
    },
    {
        "id": 456,
        "question": "What is the penalty for a first-degree misdemeanor violation of Florida real estate law?",
        "answer": "A fine of up to $1,000 and/or up to one year in jail.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "This can include offenses such as practicing real estate without a valid license."
    },
    {
        "id": 457,
        "question": "What is the penalty for a third-degree felony violation of Florida real estate law?",
        "answer": "A fine of up to $5,000 and/or up to five years in prison.",
        "category": "Violations and Penalties",
        "difficulty": "hard",
        "explanation": "This is a serious offense that can include acting as a real estate professional without a license."
    },
    {
        "id": 458,
        "question": "What is the purpose of the FREC's probable cause panel?",
        "answer": "To investigate complaints against licensees and determine if there is probable cause for disciplinary action.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "The panel is made up of two members of the FREC, one of whom must be a professional member."
    },
    {
        "id": 459,
        "question": "What is a 'cease and desist' order?",
        "answer": "An order from the DBPR to stop an unlicensed person from conducting real estate activities.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "This order can be issued without a formal hearing and is legally binding."
    },
    {
        "id": 460,
        "question": "What is the penalty for 'commingling' of funds?",
        "answer": "A fine of up to $5,000, license suspension, or license revocation.",
        "category": "Violations and Penalties",
        "difficulty": "hard",
        "explanation": "Commingling is a serious violation of license law."
    },
    {
        "id": 461,
        "question": "What is the maximum payment from the Real Estate Recovery Fund for a single transaction?",
        "answer": "$50,000.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "The total maximum payment for a single licensee is $150,000."
    },
    {
        "id": 462,
        "question": "When can a broker's license be suspended?",
        "answer": "For a range of offenses, including violations of license law, mishandling of escrow funds, or engaging in fraudulent activity.",
        "category": "Violations and Penalties",
        "difficulty": "easy",
        "explanation": "License suspension is a temporary removal of the license."
    },
    {
        "id": 463,
        "question": "What is the penalty for a real estate licensee who provides false information on their license application?",
        "answer": "A third-degree felony.",
        "category": "Violations and Penalties",
        "difficulty": "hard",
        "explanation": "Providing false information on a license application is a serious offense."
    },
    {
        "id": 464,
        "question": "What is a 'formal complaint' in the disciplinary process?",
        "answer": "A document filed by the DBPR against a licensee after a probable cause determination.",
        "category": "Violations and Penalties",
        "difficulty": "medium",
        "explanation": "The complaint outlines the specific charges against the licensee and leads to a formal hearing."
    },
    {
        "id": 465,
        "question": "What is the 'Real Estate Recovery Fund'?",
        "answer": "A fund of last resort that compensates consumers who have been financially harmed by a licensee's actions.",
        "category": "Violations and Penalties",
        "difficulty": "easy",
        "explanation": "The fund is a consumer protection mechanism."
    },
    {
        "id": 466,
        "question": "What is a 'business opportunity brokerage'?",
        "answer": "The sale or lease of a business that includes a real estate interest.",
        "category": "Investments and Business Brokerage",
        "difficulty": "easy",
        "explanation": "A real estate license is required to sell a business if it includes a real estate component, like a building or a long-term lease."
    },
    {
        "id": 467,
        "question": "What is the difference between an asset sale and a stock sale of a business?",
        "answer": "An asset sale transfers ownership of the business's assets; a stock sale transfers ownership of the business entity itself.",
        "category": "Investments and Business Brokerage",
        "difficulty": "hard",
        "explanation": "A stock sale transfers ownership of the business's legal entity, including its liabilities."
    },
    {
        "id": 468,
        "question": "What is a 'going concern value'?",
        "answer": "The value of a business as a whole, including its goodwill, brand reputation, and future earning potential.",
        "category": "Investments and Business Brokerage",
        "difficulty": "medium",
        "explanation": "This value is often higher than the sum of the business's individual assets."
    },
    {
        "id": 469,
        "question": "What is a 'chattel mortgage'?",
        "answer": "A mortgage secured by personal property, such as furniture or equipment, as part of a business sale.",
        "category": "Investments and Business Brokerage",
        "difficulty": "hard",
        "explanation": "This is a common form of financing for a business that includes movable assets."
    },
    {
        "id": 470,
        "question": "What is the purpose of a 'liquor license' in a business sale?",
        "answer": "To allow the new business owner to legally sell alcoholic beverages, which is often a key component of a business's value.",
        "category": "Investments and Business Brokerage",
        "difficulty": "easy",
        "explanation": "The transfer of a liquor license is a critical part of a business sale."
    },
    {
        "id": 471,
        "question": "What is 'leverage' in real estate investment?",
        "answer": "The use of borrowed funds to finance the purchase of a property.",
        "category": "Investments and Business Brokerage",
        "difficulty": "easy",
        "explanation": "Leverage allows an investor to control a property with a smaller amount of their own money."
    },
    {
        "id": 472,
        "question": "What is 'equity' in real estate?",
        "answer": "The difference between the market value of a property and the amount owed on the mortgage.",
        "category": "Investments and Business Brokerage",
        "difficulty": "easy",
        "explanation": "Equity is the portion of a property that the owner actually owns."
    },
    {
        "id": 473,
        "question": "What is a 'business enterprise value'?",
        "answer": "The total value of a business, including its real estate, equipment, and intangible assets.",
        "category": "Investments and Business Brokerage",
        "difficulty": "medium",
        "explanation": "This value is often used to assess a business's total worth for a potential buyer."
    },
    {
        "id": 474,
        "question": "What is a 'business broker'?",
        "answer": "A licensed real estate professional who specializes in the sale and transfer of businesses.",
        "category": "Investments and Business Brokerage",
        "difficulty": "easy",
        "explanation": "A business broker is an expert in valuing and marketing businesses."
    },
    {
        "id": 475,
        "question": "What is 'goodwill' in a business sale?",
        "answer": "An intangible asset that represents the value of a business's brand, reputation, and customer loyalty.",
        "category": "Investments and Business Brokerage",
        "difficulty": "medium",
        "explanation": "Goodwill is often a significant portion of the total sales price of a business."
    },
    {
        "id": 476,
        "question": "What is the purpose of the Florida Real Estate Commission (FREC)?",
        "answer": "To protect the public by regulating and disciplining licensees, and to adopt rules for the profession.",
        "category": "License Law and Commission Rules",
        "difficulty": "easy",
        "explanation": "The FREC is the quasi-judicial body that enforces the real estate license law."
    },
    {
        "id": 477,
        "question": "What is the 'Division of Real Estate' (DRE)?",
        "answer": "An administrative body within the DBPR that provides administrative support to the FREC.",
        "category": "License Law and Commission Rules",
        "difficulty": "medium",
        "explanation": "The DRE handles the day-to-day operations of license applications and renewals."
    },
    {
        "id": 478,
        "question": "What is 'prima facie' evidence of licensure?",
        "answer": "The real estate license itself, which is legal proof that a person is licensed.",
        "category": "License Law and Commission Rules",
        "difficulty": "medium",
        "explanation": "This means the license is considered valid on its face."
    },
    {
        "id": 479,
        "question": "What is 'voluntarily inactive' license status?",
        "answer": "A license status that a licensee chooses to enter when they are not practicing real estate.",
        "category": "License Law and Commission Rules",
        "difficulty": "easy",
        "explanation": "An inactive licensee can reactivate their license by completing the required continuing education."
    },
    {
        "id": 480,
        "question": "What is 'involuntarily inactive' license status?",
        "answer": "A license status that results from a licensee's failure to renew their license or complete the required education.",
        "category": "License Law and Commission Rules",
        "difficulty": "medium",
        "explanation": "This status can be maintained for up to two years before the license becomes null and void."
    },
    {
        "id": 481,
        "question": "What is the purpose of the FREC's rules and regulations?",
        "answer": "To provide specific guidance and standards for licensees to follow in their professional practice.",
        "category": "License Law and Commission Rules",
        "difficulty": "easy",
        "explanation": "The rules are a formal clarification of the license law."
    },
    {
        "id": 482,
        "question": "What is the 'Brokerage Relationship Disclosure Act'?",
        "answer": "A Florida law that requires licensees to clearly disclose their relationship with customers and clients.",
        "category": "License Law and Commission Rules",
        "difficulty": "medium",
        "explanation": "This act eliminated the previous assumption of single agency."
    },
    {
        "id": 483,
        "question": "How are FREC members appointed?",
        "answer": "By the Governor of Florida.",
        "category": "License Law and Commission Rules",
        "difficulty": "easy",
        "explanation": "The commission is made up of seven members, five of whom are licensed professionals."
    },
    {
        "id": 484,
        "question": "What is the difference between a license 'registration' and a license 'certification'?",
        "answer": "A registration is a record maintained by the DBPR; a certification is a recognition that a licensee meets certain standards.",
        "category": "License Law and Commission Rules",
        "difficulty": "hard",
        "explanation": "A brokerage is registered, while an individual is certified."
    },
    {
        "id": 485,
        "question": "What is the penalty for a licensee who fails to notify the DBPR of a change in address?",
        "answer": "A fine of up to $500.",
        "category": "License Law and Commission Rules",
        "difficulty": "hard",
        "explanation": "This is a violation of license law that is punishable by a fine."
    },
    {
        "id": 486,
        "question": "What are the five major components of the real estate business?",
        "answer": "Residential, commercial, industrial, agricultural, and business opportunity.",
        "category": "The Real Estate Business",
        "difficulty": "easy",
        "explanation": "These five categories cover the main types of properties that licensees can specialize in."
    },
    {
        "id": 487,
        "question": "What is the role of a 'property manager'?",
        "answer": "To manage a property on behalf of an owner, including marketing, leasing, and maintenance.",
        "category": "The Real Estate Business",
        "difficulty": "easy",
        "explanation": "A property manager must hold a real estate license in Florida if they are paid a commission."
    },
    {
        "id": 488,
        "question": "What is 'commercial real estate'?",
        "answer": "Real estate used for business purposes, such as office buildings, retail spaces, and warehouses.",
        "category": "The Real Estate Business",
        "difficulty": "easy",
        "explanation": "This type of real estate is for business use, not residential."
    },
    {
        "id": 489,
        "question": "What is 'agricultural real estate'?",
        "answer": "Real estate used for agricultural purposes, such as farms, ranches, and timberland.",
        "category": "The Real Estate Business",
        "difficulty": "easy",
        "explanation": "This is a highly specialized area of real estate."
    },
    {
        "id": 490,
        "question": "What is the role of a 'subdivider'?",
        "answer": "A person who buys undeveloped land and divides it into smaller parcels for sale or development.",
        "category": "The Real Estate Business",
        "difficulty": "easy",
        "explanation": "A subdivider is an important part of the real estate development process."
    },
    {
        "id": 491,
        "question": "What is a 'seller's market'?",
        "answer": "A market where the demand for homes exceeds the supply, leading to higher prices and a faster sales cycle.",
        "category": "Real Estate Markets and Analysis",
        "difficulty": "easy",
        "explanation": "In a seller's market, buyers have less negotiating power."
    },
    {
        "id": 492,
        "question": "What is a 'buyer's market'?",
        "answer": "A market where the supply of homes exceeds the demand, leading to lower prices and a longer sales cycle.",
        "category": "Real Estate Markets and Analysis",
        "difficulty": "easy",
        "explanation": "In a buyer's market, buyers have more negotiating power."
    },
    {
        "id": 493,
        "question": "What is 'liquidity' in real estate?",
        "answer": "The ease with which an asset can be converted into cash.",
        "category": "Real Estate Markets and Analysis",
        "difficulty": "medium",
        "explanation": "Real estate is considered an illiquid asset because it takes time to sell and convert into cash."
    },
    {
        "id": 494,
        "question": "What is a 'balanced market'?",
        "answer": "A market where the supply and demand for homes are in equilibrium, leading to stable prices.",
        "category": "Real Estate Markets and Analysis",
        "difficulty": "easy",
        "explanation": "A balanced market is ideal for both buyers and sellers."
    },
    {
        "id": 495,
        "question": "What is the 'economic base' of a city?",
        "answer": "The primary industry or source of income for a community, which drives its economy and real estate market.",
        "category": "Real Estate Markets and Analysis",
        "difficulty": "medium",
        "explanation": "An economic base can be a major employer, such as a university or a large corporation."
    },
    {
        "id": 496,
        "question": "What is a 'zoning ordinance'?",
        "answer": "A local law that regulates the use of land, such as the type of buildings allowed or the density of development.",
        "category": "Planning and Zoning",
        "difficulty": "easy",
        "explanation": "Zoning is an exercise of the government's police power."
    },
    {
        "id": 497,
        "question": "What is a 'variance' in zoning?",
        "answer": "An exception to a zoning ordinance that allows a property owner to use their property in a way that is otherwise prohibited.",
        "category": "Planning and Zoning",
        "difficulty": "medium",
        "explanation": "A variance is granted for a specific hardship and does not change the zoning of the property."
    },
    {
        "id": 498,
        "question": "What is a 'non-conforming use'?",
        "answer": "A property use that was legal before a zoning change but is no longer in compliance with the new zoning laws.",
        "category": "Planning and Zoning",
        "difficulty": "medium",
        "explanation": "The use is allowed to continue as long as it is not expanded or rebuilt."
    },
    {
        "id": 499,
        "question": "What is a 'special exception' in zoning?",
        "answer": "A specific use that is permitted in a particular zone, provided certain conditions are met.",
        "category": "Planning and Zoning",
        "difficulty": "hard",
        "explanation": "An example is a church in a residential neighborhood that is granted a special exception."
    },
    {
        "id": 500,
        "question": "What is 'zoning'?",
        "answer": "A local government's power to regulate land use to promote public health, safety, and welfare.",
        "category": "Planning and Zoning",
        "difficulty": "easy",
        "explanation": "Zoning is a key tool for city planning and development."
    }
]
